/* tslint:disable */
/* eslint-disable */
import { GraphQLResolveInfo, GraphQLScalarType } from 'graphql';
/**
 * This file is auto-generated by graphql-schema-typescript
 * Please note that any changes in this file may be overwritten
 */
 

/*******************************
 *                             *
 *          TYPE DEFS          *
 *                             *
 *******************************/
/**
 * An object with an ID
 */
export interface GQLNode {
  
  /**
   * The id of the object.
   */
  id: string;
}

/** Use this to resolve interface type Node */
export type GQLPossibleNodeTypeNames =
'AppFile' |
'AuthMetamask' |
'Instance' |
'InstancePayment' |
'Invoice' |
'Role' |
'Session' |
'User' |
'Validator' |
'ValidatorPayment';

export interface GQLNodeNameMap {
  Node: GQLNode;
  AppFile: GQLAppFile;
  AuthMetamask: GQLAuthMetamask;
  Instance: GQLInstance;
  InstancePayment: GQLInstancePayment;
  Invoice: GQLInvoice;
  Role: GQLRole;
  Session: GQLSession;
  User: GQLUser;
  Validator: GQLValidator;
  ValidatorPayment: GQLValidatorPayment;
}

/**
 * The ParseObject interface type is used as a base type for the auto generated object types.
 */
export interface GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/** Use this to resolve interface type ParseObject */
export type GQLPossibleParseObjectTypeNames =
'AppFile' |
'AuthMetamask' |
'Instance' |
'InstancePayment' |
'Invoice' |
'Role' |
'Session' |
'User' |
'Validator' |
'ValidatorPayment';

export interface GQLParseObjectNameMap {
  ParseObject: GQLParseObject;
  AppFile: GQLAppFile;
  AuthMetamask: GQLAuthMetamask;
  Instance: GQLInstance;
  InstancePayment: GQLInstancePayment;
  Invoice: GQLInvoice;
  Role: GQLRole;
  Session: GQLSession;
  User: GQLUser;
  Validator: GQLValidator;
  ValidatorPayment: GQLValidatorPayment;
}

/**
 * The SchemaField interface type is used as a base type for the different supported fields of an object class schema.
 */
export interface GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/** Use this to resolve interface type SchemaField */
export type GQLPossibleSchemaFieldTypeNames =
'SchemaACLField' |
'SchemaArrayField' |
'SchemaBooleanField' |
'SchemaBytesField' |
'SchemaDateField' |
'SchemaFileField' |
'SchemaGeoPointField' |
'SchemaNumberField' |
'SchemaObjectField' |
'SchemaPointerField' |
'SchemaPolygonField' |
'SchemaRelationField' |
'SchemaStringField';

export interface GQLSchemaFieldNameMap {
  SchemaField: GQLSchemaField;
  SchemaACLField: GQLSchemaACLField;
  SchemaArrayField: GQLSchemaArrayField;
  SchemaBooleanField: GQLSchemaBooleanField;
  SchemaBytesField: GQLSchemaBytesField;
  SchemaDateField: GQLSchemaDateField;
  SchemaFileField: GQLSchemaFileField;
  SchemaGeoPointField: GQLSchemaGeoPointField;
  SchemaNumberField: GQLSchemaNumberField;
  SchemaObjectField: GQLSchemaObjectField;
  SchemaPointerField: GQLSchemaPointerField;
  SchemaPolygonField: GQLSchemaPolygonField;
  SchemaRelationField: GQLSchemaRelationField;
  SchemaStringField: GQLSchemaStringField;
}

/**
 * Use Inline Fragment on Array to get results: https://graphql.org/learn/queries/#inline-fragments
 */
export type GQLArrayResult =
GQLAppFile |
GQLAuthMetamask |
GQLElement |
GQLInstance |
GQLInstancePayment |
GQLInvoice |
GQLRole |
GQLSession |
GQLUser |
GQLValidator |
GQLValidatorPayment;

/** Use this to resolve union type ArrayResult */
export type GQLPossibleArrayResultTypeNames =
'AppFile' |
'AuthMetamask' |
'Element' |
'Instance' |
'InstancePayment' |
'Invoice' |
'Role' |
'Session' |
'User' |
'Validator' |
'ValidatorPayment';

export interface GQLArrayResultNameMap {
  ArrayResult: GQLArrayResult;
  AppFile: GQLAppFile;
  AuthMetamask: GQLAuthMetamask;
  Element: GQLElement;
  Instance: GQLInstance;
  InstancePayment: GQLInstancePayment;
  Invoice: GQLInvoice;
  Role: GQLRole;
  Session: GQLSession;
  User: GQLUser;
  Validator: GQLValidator;
  ValidatorPayment: GQLValidatorPayment;
}

/**
 * Current access control list of the current object.
 */
export interface GQLACL {
  
  /**
   * Public access control list.
   */
  public?: GQLPublicACL;
  
  /**
   * Access control list for roles.
   */
  roles?: Array<GQLRoleACL>;
  
  /**
   * Access control list for users.
   */
  users?: Array<GQLUserACL>;
}

export interface GQLAddValidatorPayload {
  instanceId?: string;
  url?: string;
}

/**
 * The AppFile object type is used in operations that involve outputting objects of AppFile class.
 */
export interface GQLAppFile extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstance;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUser;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object file.
   */
  file?: GQLFileInfo;
  
  /**
   * This is the object filePath.
   */
  filePath?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object info.
   */
  info?: GQLObject;
  
  /**
   * This is the object isResized.
   */
  isResized?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLAppFileConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLAppFileEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLAppFileEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLAppFile;
}

/**
 * The AuthMetamask object type is used in operations that involve outputting objects of AuthMetamask class.
 */
export interface GQLAuthMetamask extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLAuthMetamaskConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLAuthMetamaskEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLAuthMetamaskEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLAuthMetamask;
}

export interface GQLCallCloudCodePayload {
  clientMutationId?: string;
  
  /**
   * This is the result value of the cloud code function execution.
   */
  result?: GQLAny;
}

export interface GQLCardInfoPayload {
  address_zip?: string;
  address_zip_check?: string;
  brand?: string;
  country?: string;
  customer?: string;
  cvc_check?: string;
  exp_month: number;
  exp_year: number;
  fingerprint?: string;
  funding?: string;
  id: string;
  last4: string;
  name?: string;
  object?: string;
}

export interface GQLChallengePayload {
  
  /**
   * Challenge response from configured auth adapters.
   */
  challengeData?: GQLObject;
  clientMutationId?: string;
}

export interface GQLChangePasswordPayload {
  clientMutationId?: string;
  ok: boolean;
}

/**
 * The Class type is used to return the information about an object class.
 */
export interface GQLClass {
  
  /**
   * This is the name of the object class.
   */
  name: string;
  
  /**
   * These are the schema's fields of the object class.
   */
  schemaFields: Array<GQLSchemaField>;
}

export interface GQLConfirmResetPasswordPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

export interface GQLCreateAppFilePayload {
  
  /**
   * This is the created object.
   */
  appFile: GQLAppFile;
  clientMutationId?: string;
}

export interface GQLCreateAuthMetamaskPayload {
  
  /**
   * This is the created object.
   */
  authMetamask: GQLAuthMetamask;
  clientMutationId?: string;
}

export interface GQLCreateClassPayload {
  
  /**
   * This is the created class.
   */
  class: GQLClass;
  clientMutationId?: string;
}

export interface GQLCreateFilePayload {
  clientMutationId?: string;
  
  /**
   * This is the created file info.
   */
  fileInfo: GQLFileInfo;
}

export interface GQLCreateInstancePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  instance: GQLInstance;
}

export interface GQLCreateInstancePaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  instancePayment: GQLInstancePayment;
}

export interface GQLCreateInvoicePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  invoice: GQLInvoice;
}

export interface GQLCreateRolePayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  role: GQLRole;
}

export interface GQLCreateSessionPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  session: GQLSession;
}

export interface GQLCreateUserPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  user: GQLUser;
}

export interface GQLCreateValidatorPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  validator: GQLValidator;
}

export interface GQLCreateValidatorPaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the created object.
   */
  validatorPayment: GQLValidatorPayment;
}

export interface GQLDeleteAppFilePayload {
  
  /**
   * This is the deleted object.
   */
  appFile: GQLAppFile;
  clientMutationId?: string;
}

export interface GQLDeleteAuthMetamaskPayload {
  
  /**
   * This is the deleted object.
   */
  authMetamask: GQLAuthMetamask;
  clientMutationId?: string;
}

export interface GQLDeleteClassPayload {
  
  /**
   * This is the deleted class.
   */
  class: GQLClass;
  clientMutationId?: string;
}

export interface GQLDeleteInstancePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  instance: GQLInstance;
}

export interface GQLDeleteInstancePaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  instancePayment: GQLInstancePayment;
}

export interface GQLDeleteInvoicePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  invoice: GQLInvoice;
}

export interface GQLDeleteRolePayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  role: GQLRole;
}

export interface GQLDeleteSessionPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  session: GQLSession;
}

export interface GQLDeleteUserPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  user: GQLUser;
}

export interface GQLDeleteValidatorPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  validator: GQLValidator;
}

export interface GQLDeleteValidatorPaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the deleted object.
   */
  validatorPayment: GQLValidatorPayment;
}

/**
 * The Element object type is used to return array items' value.
 */
export interface GQLElement {
  
  /**
   * Return the value of the element in the array
   */
  value: GQLAny;
}

/**
 * The FileInfo object type is used to return the information about files.
 */
export interface GQLFileInfo {
  
  /**
   * This is the file name.
   */
  name: string;
  
  /**
   * This is the url in which the file can be downloaded.
   */
  url: string;
}

/**
 * The GeoPoint object type is used to return the information about geo point fields.
 */
export interface GQLGeoPoint {
  
  /**
   * This is the latitude.
   */
  latitude: number;
  
  /**
   * This is the longitude.
   */
  longitude: number;
}

export interface GQLGetAuthIdPayload {
  token?: string;
}

export interface GQLGetKYCTokenPayload {
  created?: string;
  expire?: string;
  token?: string;
  used?: boolean;
}

export interface GQLGetRatesPayload {
  rates?: Array<GQLRate | null>;
}

export interface GQLGetUserCardsPayload {
  cards?: Array<GQLCardInfoPayload | null>;
  defaultCardId?: string;
}

/**
 * The Instance object type is used in operations that involve outputting objects of Instance class.
 */
export interface GQLInstance extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object Validators.
   */
  Validators: GQLValidatorConnection;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object datacenter.
   */
  datacenter?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object instanceId.
   */
  instanceId?: string;
  
  /**
   * This is the object isSyncing.
   */
  isSyncing?: boolean;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object privateIP.
   */
  privateIP?: string;
  
  /**
   * This is the object publicIP.
   */
  publicIP?: string;
  
  /**
   * This is the object region.
   */
  region?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object updateStatus.
   */
  updateStatus?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object zone.
   */
  zone?: string;
}

/**
 * A connection to a list of items.
 */
export interface GQLInstanceConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLInstanceEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLInstanceEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLInstance;
}

/**
 * The InstancePayment object type is used in operations that involve outputting objects of InstancePayment class.
 */
export interface GQLInstancePayment extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstance;
  
  /**
   * This is the object Invoices.
   */
  Invoices: GQLInvoiceConnection;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object amount.
   */
  amount?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object lastInvoice.
   */
  lastInvoice?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object paymentCheck.
   */
  paymentCheck?: GQLDate;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeCardId.
   */
  stripeCardId?: string;
  
  /**
   * This is the object stripeSubsId.
   */
  stripeSubsId?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLInstancePaymentConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLInstancePaymentEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLInstancePaymentEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLInstancePayment;
}

/**
 * The Invoice object type is used in operations that involve outputting objects of Invoice class.
 */
export interface GQLInvoice extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstance;
  
  /**
   * This is the object InstancePayment.
   */
  InstancePayment?: GQLInstancePayment;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object created.
   */
  created?: number;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object currency.
   */
  currency?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object invoice_pdf.
   */
  invoice_pdf?: string;
  
  /**
   * This is the object number.
   */
  number?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object subscription.
   */
  subscription?: string;
  
  /**
   * This is the object total.
   */
  total?: number;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object url.
   */
  url?: string;
}

/**
 * A connection to a list of items.
 */
export interface GQLInvoiceConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLInvoiceEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLInvoiceEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLInvoice;
}

export interface GQLLogInPayload {
  clientMutationId?: string;
  
  /**
   * This is the existing user that was logged in and returned as a viewer.
   */
  viewer: GQLViewer;
}

export interface GQLLogInWithPayload {
  clientMutationId?: string;
  
  /**
   * This is the new user that was created, signed up and returned as a viewer.
   */
  viewer: GQLViewer;
}

export interface GQLLogOutPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

/**
 * Mutation is the top level type for mutations.
 */
export interface GQLMutation {
  addValidator: GQLAddValidatorPayload;
  adminCreateUser?: GQLCreateUserPayload;
  adminDeleteUser?: GQLDeleteUserPayload;
  adminLogin?: GQLLogInPayload;
  adminUpdateUser?: GQLUpdateUserPayload;
  
  /**
   * The callCloudCode mutation can be used to invoke a cloud code function.
   */
  callCloudCode?: GQLCallCloudCodePayload;
  
  /**
   * The challenge mutation can be used to initiate an authentication challenge when an auth adapter needs it.
   */
  challenge?: GQLChallengePayload;
  changePassword?: GQLChangePasswordPayload;
  
  /**
   * The confirmResetPassword mutation can be used to reset the password of an existing user.
   */
  confirmResetPassword?: GQLConfirmResetPasswordPayload;
  
  /**
   * The createAppFile mutation can be used to create a new object of the AppFile class.
   */
  createAppFile?: GQLCreateAppFilePayload;
  
  /**
   * The createAuthMetamask mutation can be used to create a new object of the AuthMetamask class.
   */
  createAuthMetamask?: GQLCreateAuthMetamaskPayload;
  
  /**
   * The createClass mutation can be used to create the schema for a new object class.
   */
  createClass?: GQLCreateClassPayload;
  
  /**
   * The createFile mutation can be used to create and upload a new file.
   */
  createFile?: GQLCreateFilePayload;
  
  /**
   * The createInstance mutation can be used to create a new object of the Instance class.
   */
  createInstance?: GQLCreateInstancePayload;
  
  /**
   * The createInstancePayment mutation can be used to create a new object of the InstancePayment class.
   */
  createInstancePayment?: GQLCreateInstancePaymentPayload;
  
  /**
   * The createInvoice mutation can be used to create a new object of the Invoice class.
   */
  createInvoice?: GQLCreateInvoicePayload;
  
  /**
   * The createRole mutation can be used to create a new object of the Role class.
   */
  createRole?: GQLCreateRolePayload;
  
  /**
   * The createSession mutation can be used to create a new object of the Session class.
   */
  createSession?: GQLCreateSessionPayload;
  
  /**
   * The createUser mutation can be used to create a new object of the User class.
   */
  createUser?: GQLCreateUserPayload;
  
  /**
   * The createValidator mutation can be used to create a new object of the Validator class.
   */
  createValidator?: GQLCreateValidatorPayload;
  
  /**
   * The createValidatorPayment mutation can be used to create a new object of the ValidatorPayment class.
   */
  createValidatorPayment?: GQLCreateValidatorPaymentPayload;
  
  /**
   * The deleteAppFile mutation can be used to delete an object of the AppFile class.
   */
  deleteAppFile?: GQLDeleteAppFilePayload;
  
  /**
   * The deleteAuthMetamask mutation can be used to delete an object of the AuthMetamask class.
   */
  deleteAuthMetamask?: GQLDeleteAuthMetamaskPayload;
  
  /**
   * The deleteClass mutation can be used to delete an existing object class.
   */
  deleteClass?: GQLDeleteClassPayload;
  
  /**
   * The deleteInstance mutation can be used to delete an object of the Instance class.
   */
  deleteInstance?: GQLDeleteInstancePayload;
  
  /**
   * The deleteInstancePayment mutation can be used to delete an object of the InstancePayment class.
   */
  deleteInstancePayment?: GQLDeleteInstancePaymentPayload;
  
  /**
   * The deleteInvoice mutation can be used to delete an object of the Invoice class.
   */
  deleteInvoice?: GQLDeleteInvoicePayload;
  
  /**
   * The deleteRole mutation can be used to delete an object of the Role class.
   */
  deleteRole?: GQLDeleteRolePayload;
  
  /**
   * The deleteSession mutation can be used to delete an object of the Session class.
   */
  deleteSession?: GQLDeleteSessionPayload;
  
  /**
   * The deleteUser mutation can be used to delete an object of the User class.
   */
  deleteUser?: GQLDeleteUserPayload;
  
  /**
   * The deleteValidator mutation can be used to delete an object of the Validator class.
   */
  deleteValidator?: GQLDeleteValidatorPayload;
  
  /**
   * The deleteValidatorPayment mutation can be used to delete an object of the ValidatorPayment class.
   */
  deleteValidatorPayment?: GQLDeleteValidatorPaymentPayload;
  geKYCToken: GQLGetKYCTokenPayload;
  getAuthId?: GQLGetAuthIdPayload;
  getPaymentConfig: GQLgetPaymentConfigPayload;
  getRates: GQLGetRatesPayload;
  
  /**
   * The logIn mutation can be used to log in an existing user.
   */
  logIn?: GQLLogInPayload;
  
  /**
   * The logInWith mutation can be used to signup, login user with 3rd party authentication system. This mutation create a user if the authData do not correspond to an existing one.
   */
  logInWith?: GQLLogInWithPayload;
  
  /**
   * The logOut mutation can be used to log out an existing user.
   */
  logOut?: GQLLogOutPayload;
  paymentAddCard: boolean;
  paymentDeleteCard: boolean;
  paymentGetUserCards: GQLGetUserCardsPayload;
  paymentSetDefaultCard: boolean;
  repaySubscription: string;
  
  /**
   * The resetPassword mutation can be used to reset the password of an existing user.
   */
  resetPassword?: GQLResetPasswordPayload;
  
  /**
   * The sendVerificationEmail mutation can be used to send the verification email again.
   */
  sendVerificationEmail?: GQLSendVerificationEmailPayload;
  
  /**
   * The signUp mutation can be used to create and sign up a new user.
   */
  signUp?: GQLSignUpPayload;
  
  /**
   * The updateAppFile mutation can be used to update an object of the AppFile class.
   */
  updateAppFile?: GQLUpdateAppFilePayload;
  
  /**
   * The updateAuthMetamask mutation can be used to update an object of the AuthMetamask class.
   */
  updateAuthMetamask?: GQLUpdateAuthMetamaskPayload;
  
  /**
   * The updateClass mutation can be used to update the schema for an existing object class.
   */
  updateClass?: GQLUpdateClassPayload;
  
  /**
   * The updateInstance mutation can be used to update an object of the Instance class.
   */
  updateInstance?: GQLUpdateInstancePayload;
  
  /**
   * The updateInstancePayment mutation can be used to update an object of the InstancePayment class.
   */
  updateInstancePayment?: GQLUpdateInstancePaymentPayload;
  
  /**
   * The updateInvoice mutation can be used to update an object of the Invoice class.
   */
  updateInvoice?: GQLUpdateInvoicePayload;
  
  /**
   * The updateRole mutation can be used to update an object of the Role class.
   */
  updateRole?: GQLUpdateRolePayload;
  
  /**
   * The updateSession mutation can be used to update an object of the Session class.
   */
  updateSession?: GQLUpdateSessionPayload;
  
  /**
   * The updateUser mutation can be used to update an object of the User class.
   */
  updateUser?: GQLUpdateUserPayload;
  
  /**
   * The updateValidator mutation can be used to update an object of the Validator class.
   */
  updateValidator?: GQLUpdateValidatorPayload;
  
  /**
   * The updateValidatorPayment mutation can be used to update an object of the ValidatorPayment class.
   */
  updateValidatorPayment?: GQLUpdateValidatorPaymentPayload;
  verifyEmail?: GQLVerifyEmailPayload;
}

/**
 * Information about pagination in a connection.
 */
export interface GQLPageInfo {
  
  /**
   * When paginating forwards, the cursor to continue.
   */
  endCursor?: string;
  
  /**
   * When paginating forwards, are there more items?
   */
  hasNextPage: boolean;
  
  /**
   * When paginating backwards, are there more items?
   */
  hasPreviousPage: boolean;
  
  /**
   * When paginating backwards, the cursor to continue.
   */
  startCursor?: string;
}

export interface GQLPaymentConfig {
  address?: string;
  amount?: string;
  chainId?: number;
  contract?: string;
  countConfirmation?: number;
  label?: string;
  rpc?: string;
  symbol?: string;
  value?: string;
}

/**
 * Allow to manage public rights.
 */
export interface GQLPublicACL {
  
  /**
   * Allow anyone to read the current object.
   */
  read?: boolean;
  
  /**
   * Allow anyone to write on the current object.
   */
  write?: boolean;
}

/**
 * Query is the top level type for queries.
 */
export interface GQLQuery {
  
  /**
   * The appFile query can be used to get an object of the AppFile class by its id.
   */
  appFile: GQLAppFile;
  
  /**
   * The appFiles query can be used to find objects of the AppFile class.
   */
  appFiles: GQLAppFileConnection;
  
  /**
   * The authMetamask query can be used to get an object of the AuthMetamask class by its id.
   */
  authMetamask: GQLAuthMetamask;
  
  /**
   * The authMetamasks query can be used to find objects of the AuthMetamask class.
   */
  authMetamasks: GQLAuthMetamaskConnection;
  
  /**
   * The class query can be used to retrieve an existing object class.
   */
  class: GQLClass;
  
  /**
   * The classes query can be used to retrieve the existing object classes.
   */
  classes: Array<GQLClass>;
  
  /**
   * The health query can be used to check if the server is up and running.
   */
  health: boolean;
  
  /**
   * The instance query can be used to get an object of the Instance class by its id.
   */
  instance: GQLInstance;
  
  /**
   * The instancePayment query can be used to get an object of the InstancePayment class by its id.
   */
  instancePayment: GQLInstancePayment;
  
  /**
   * The instancePayments query can be used to find objects of the InstancePayment class.
   */
  instancePayments: GQLInstancePaymentConnection;
  
  /**
   * The instances query can be used to find objects of the Instance class.
   */
  instances: GQLInstanceConnection;
  
  /**
   * The invoice query can be used to get an object of the Invoice class by its id.
   */
  invoice: GQLInvoice;
  
  /**
   * The invoices query can be used to find objects of the Invoice class.
   */
  invoices: GQLInvoiceConnection;
  
  /**
   * Fetches an object given its ID
   */
  node?: GQLNode;
  
  /**
   * The role query can be used to get an object of the Role class by its id.
   */
  role: GQLRole;
  
  /**
   * The roles query can be used to find objects of the Role class.
   */
  roles: GQLRoleConnection;
  searchSessions?: GQLSessionConnection;
  
  /**
   * The session query can be used to get an object of the Session class by its id.
   */
  session: GQLSession;
  
  /**
   * The sessions query can be used to find objects of the Session class.
   */
  sessions: GQLSessionConnection;
  
  /**
   * The user query can be used to get an object of the User class by its id.
   */
  user: GQLUser;
  
  /**
   * The users query can be used to find objects of the User class.
   */
  users: GQLUserConnection;
  
  /**
   * The validator query can be used to get an object of the Validator class by its id.
   */
  validator: GQLValidator;
  
  /**
   * The validatorPayment query can be used to get an object of the ValidatorPayment class by its id.
   */
  validatorPayment: GQLValidatorPayment;
  
  /**
   * The validatorPayments query can be used to find objects of the ValidatorPayment class.
   */
  validatorPayments: GQLValidatorPaymentConnection;
  
  /**
   * The validators query can be used to find objects of the Validator class.
   */
  validators: GQLValidatorConnection;
  
  /**
   * The viewer query can be used to return the current user data.
   */
  viewer: GQLViewer;
}

export interface GQLRate {
  datacenter?: string;
  zones?: Array<GQLZone | null>;
}

export interface GQLRegion {
  countWorker?: number;
  id?: string;
  name?: string;
  priceAmount?: number;
  priceId?: string;
  productId?: string;
  workerPrices?: GQLObject;
}

export interface GQLResetPasswordPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

/**
 * The Role object type is used in operations that involve outputting objects of Role class.
 */
export interface GQLRole extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object roles.
   */
  roles: GQLRoleConnection;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object users.
   */
  users: GQLUserConnection;
}

/**
 * Allow to manage roles in ACL. If read and write are null the role have read and write rights.
 */
export interface GQLRoleACL {
  
  /**
   * Allow users who are members of the role to read the current object.
   */
  read: boolean;
  
  /**
   * Name of the targetted Role.
   */
  roleName: string;
  
  /**
   * Allow users who are members of the role to write on the current object.
   */
  write: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GQLRoleConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLRoleEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLRoleEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLRole;
}

/**
 * The SchemaACLField is used to return information of an ACL field.
 */
export interface GQLSchemaACLField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaArrayField is used to return information of an Array field.
 */
export interface GQLSchemaArrayField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBooleanField is used to return information of a Boolean field.
 */
export interface GQLSchemaBooleanField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBytesField is used to return information of a Bytes field.
 */
export interface GQLSchemaBytesField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaDateField is used to return information of a Date field.
 */
export interface GQLSchemaDateField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaFileField is used to return information of a File field.
 */
export interface GQLSchemaFileField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaGeoPointField is used to return information of a Geo Point field.
 */
export interface GQLSchemaGeoPointField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaNumberField is used to return information of a Number field.
 */
export interface GQLSchemaNumberField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaObjectField is used to return information of an Object field.
 */
export interface GQLSchemaObjectField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaPointerField is used to return information of a Pointer field.
 */
export interface GQLSchemaPointerField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

/**
 * The SchemaPolygonField is used to return information of a Polygon field.
 */
export interface GQLSchemaPolygonField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaRelationField is used to return information of a Relation field.
 */
export interface GQLSchemaRelationField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

/**
 * The SchemaStringField is used to return information of a String field.
 */
export interface GQLSchemaStringField extends GQLSchemaField {
  
  /**
   * This is the field name.
   */
  name: string;
}

export interface GQLSendVerificationEmailPayload {
  clientMutationId?: string;
  
  /**
   * It's always true.
   */
  ok: boolean;
}

/**
 * The Session object type is used in operations that involve outputting objects of Session class.
 */
export interface GQLSession extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObject;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDate;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object user.
   */
  user?: GQLUser;
}

/**
 * A connection to a list of items.
 */
export interface GQLSessionConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLSessionEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLSessionEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLSession;
}

export interface GQLSignUpPayload {
  clientMutationId?: string;
  
  /**
   * This is the new user that was created, signed up and returned as a viewer.
   */
  viewer: GQLViewer;
}

export interface GQLUpdateAppFilePayload {
  
  /**
   * This is the updated object.
   */
  appFile: GQLAppFile;
  clientMutationId?: string;
}

export interface GQLUpdateAuthMetamaskPayload {
  
  /**
   * This is the updated object.
   */
  authMetamask: GQLAuthMetamask;
  clientMutationId?: string;
}

export interface GQLUpdateClassPayload {
  
  /**
   * This is the updated class.
   */
  class: GQLClass;
  clientMutationId?: string;
}

export interface GQLUpdateInstancePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  instance: GQLInstance;
}

export interface GQLUpdateInstancePaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  instancePayment: GQLInstancePayment;
}

export interface GQLUpdateInvoicePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  invoice: GQLInvoice;
}

export interface GQLUpdateRolePayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  role: GQLRole;
}

export interface GQLUpdateSessionPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  session: GQLSession;
}

export interface GQLUpdateUserPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  user: GQLUser;
}

export interface GQLUpdateValidatorPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  validator: GQLValidator;
}

export interface GQLUpdateValidatorPaymentPayload {
  clientMutationId?: string;
  
  /**
   * This is the updated object.
   */
  validatorPayment: GQLValidatorPayment;
}

/**
 * The User object type is used in operations that involve outputting objects of User class.
 */
export interface GQLUser extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObject;
  
  /**
   * auth provider response when triggered on signUp/logIn.
   */
  authDataResponse?: GQLObject;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object kycData.
   */
  kycData?: GQLObject;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object sessionId.
   */
  sessionId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object username.
   */
  username?: string;
  
  /**
   * This is the object verificationDate.
   */
  verificationDate?: GQLDate;
}

/**
 * Allow to manage users in ACL. If read and write are null the users have read and write rights.
 */
export interface GQLUserACL {
  
  /**
   * Allow the user to read the current object.
   */
  read: boolean;
  
  /**
   * ID of the targetted User.
   */
  userId: string;
  
  /**
   * Allow the user to write on the current object.
   */
  write: boolean;
}

/**
 * A connection to a list of items.
 */
export interface GQLUserConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLUserEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLUserEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLUser;
}

/**
 * The Validator object type is used in operations that involve outputting objects of Validator class.
 */
export interface GQLValidator extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstance;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object activationDate.
   */
  activationDate?: GQLDate;
  
  /**
   * This is the object coordinatorBalance.
   */
  coordinatorBalance?: string;
  
  /**
   * This is the object coordinatorPublicKey.
   */
  coordinatorPublicKey?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object depositData.
   */
  depositData?: GQLObject;
  
  /**
   * This is the object depositSent.
   */
  depositSent?: boolean;
  
  /**
   * This is the object depositTx.
   */
  depositTx?: GQLObject;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object index.
   */
  index?: number;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
  
  /**
   * This is the object validatorBalance.
   */
  validatorBalance?: string;
  
  /**
   * This is the object validatorPublicKey.
   */
  validatorPublicKey?: string;
}

/**
 * A connection to a list of items.
 */
export interface GQLValidatorConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLValidatorEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLValidatorEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLValidator;
}

/**
 * The ValidatorPayment object type is used in operations that involve outputting objects of ValidatorPayment class.
 */
export interface GQLValidatorPayment extends GQLNode, GQLParseObject {
  ACL: GQLACL;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstance;
  
  /**
   * This is the object User.
   */
  User?: GQLUser;
  
  /**
   * This is the object Validators.
   */
  Validators: GQLValidatorConnection;
  
  /**
   * This is the object amount.
   */
  amount?: string;
  
  /**
   * This is the date in which the object was created.
   */
  createdAt: GQLDate;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * The ID of an object
   */
  id: string;
  
  /**
   * This is the object network.
   */
  network?: string;
  
  /**
   * This is the object id.
   */
  objectId: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the date in which the object was las updated.
   */
  updatedAt: GQLDate;
}

/**
 * A connection to a list of items.
 */
export interface GQLValidatorPaymentConnection {
  
  /**
   * This is the total matched objecs count that is returned when the count flag is set.
   */
  count: number;
  
  /**
   * A list of edges.
   */
  edges?: Array<GQLValidatorPaymentEdge | null>;
  
  /**
   * Information to aid in pagination.
   */
  pageInfo: GQLPageInfo;
}

/**
 * An edge in a connection.
 */
export interface GQLValidatorPaymentEdge {
  
  /**
   * A cursor for use in pagination
   */
  cursor: string;
  
  /**
   * The item at the end of the edge
   */
  node?: GQLValidatorPayment;
}

export interface GQLVerifyEmailPayload {
  clientMutationId?: string;
  ok: boolean;
}

/**
 * The Viewer object type is used in operations that involve outputting the current user data.
 */
export interface GQLViewer {
  
  /**
   * The current user session token.
   */
  sessionToken: string;
  
  /**
   * This is the current user.
   */
  user: GQLUser;
}

export interface GQLZone {
  name?: string;
  regions?: Array<GQLRegion | null>;
}

export interface GQLgetPaymentConfigPayload {
  config?: Array<GQLPaymentConfig | null>;
}

/**
 * The AppFileOrder input type is used when sorting objects of the AppFile class.
 */
export enum GQLAppFileOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Instance_ASC = 'Instance_ASC',
  Instance_DESC = 'Instance_DESC',
  Owner_ASC = 'Owner_ASC',
  Owner_DESC = 'Owner_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  filePath_ASC = 'filePath_ASC',
  filePath_DESC = 'filePath_DESC',
  file_ASC = 'file_ASC',
  file_DESC = 'file_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  info_ASC = 'info_ASC',
  info_DESC = 'info_DESC',
  isResized_ASC = 'isResized_ASC',
  isResized_DESC = 'isResized_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The AuthMetamaskOrder input type is used when sorting objects of the AuthMetamask class.
 */
export enum GQLAuthMetamaskOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  address_ASC = 'address_ASC',
  address_DESC = 'address_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

/**
 * The CloudCodeFunction enum type contains a list of all available cloud code functions.
 */
export enum GQLCloudCodeFunction {
  addValidator = 'addValidator',
  adminCreateUser = 'adminCreateUser',
  adminDeleteUser = 'adminDeleteUser',
  adminLogin = 'adminLogin',
  adminUpdateUser = 'adminUpdateUser',
  changePassword = 'changePassword',
  geKYCToken = 'geKYCToken',
  getAuthId = 'getAuthId',
  getPaymentConfig = 'getPaymentConfig',
  getRates = 'getRates',
  paymentAddCard = 'paymentAddCard',
  paymentDeleteCard = 'paymentDeleteCard',
  paymentGetUserCards = 'paymentGetUserCards',
  paymentSetDefaultCard = 'paymentSetDefaultCard',
  repaySubscription = 'repaySubscription',
  searchSessions = 'searchSessions',
  verifyEmail = 'verifyEmail'
}

export enum GQLFileType {
  avatar = 'avatar'
}

/**
 * The InstanceOrder input type is used when sorting objects of the Instance class.
 */
export enum GQLInstanceOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  Validators_ASC = 'Validators_ASC',
  Validators_DESC = 'Validators_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  datacenter_ASC = 'datacenter_ASC',
  datacenter_DESC = 'datacenter_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  instanceId_ASC = 'instanceId_ASC',
  instanceId_DESC = 'instanceId_DESC',
  isSyncing_ASC = 'isSyncing_ASC',
  isSyncing_DESC = 'isSyncing_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  privateIP_ASC = 'privateIP_ASC',
  privateIP_DESC = 'privateIP_DESC',
  publicIP_ASC = 'publicIP_ASC',
  publicIP_DESC = 'publicIP_DESC',
  region_ASC = 'region_ASC',
  region_DESC = 'region_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updateStatus_ASC = 'updateStatus_ASC',
  updateStatus_DESC = 'updateStatus_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  zone_ASC = 'zone_ASC',
  zone_DESC = 'zone_DESC'
}

/**
 * The InstancePaymentOrder input type is used when sorting objects of the InstancePayment class.
 */
export enum GQLInstancePaymentOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Instance_ASC = 'Instance_ASC',
  Instance_DESC = 'Instance_DESC',
  Invoices_ASC = 'Invoices_ASC',
  Invoices_DESC = 'Invoices_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  amount_ASC = 'amount_ASC',
  amount_DESC = 'amount_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  error_ASC = 'error_ASC',
  error_DESC = 'error_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  lastInvoice_ASC = 'lastInvoice_ASC',
  lastInvoice_DESC = 'lastInvoice_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  paymentCheck_ASC = 'paymentCheck_ASC',
  paymentCheck_DESC = 'paymentCheck_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  stripeCardId_ASC = 'stripeCardId_ASC',
  stripeCardId_DESC = 'stripeCardId_DESC',
  stripeSubsId_ASC = 'stripeSubsId_ASC',
  stripeSubsId_DESC = 'stripeSubsId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQLInterval {
  day = 'day',
  month = 'month',
  week = 'week',
  year = 'year'
}

/**
 * The InvoiceOrder input type is used when sorting objects of the Invoice class.
 */
export enum GQLInvoiceOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  InstancePayment_ASC = 'InstancePayment_ASC',
  InstancePayment_DESC = 'InstancePayment_DESC',
  Instance_ASC = 'Instance_ASC',
  Instance_DESC = 'Instance_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  created_ASC = 'created_ASC',
  created_DESC = 'created_DESC',
  currency_ASC = 'currency_ASC',
  currency_DESC = 'currency_DESC',
  description_ASC = 'description_ASC',
  description_DESC = 'description_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  invoice_pdf_ASC = 'invoice_pdf_ASC',
  invoice_pdf_DESC = 'invoice_pdf_DESC',
  number_ASC = 'number_ASC',
  number_DESC = 'number_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  stripeId_ASC = 'stripeId_ASC',
  stripeId_DESC = 'stripeId_DESC',
  subscription_ASC = 'subscription_ASC',
  subscription_DESC = 'subscription_DESC',
  total_ASC = 'total_ASC',
  total_DESC = 'total_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  url_ASC = 'url_ASC',
  url_DESC = 'url_DESC'
}

export enum GQLPaymentMethod {
  bsc_bnb = 'bsc_bnb',
  eth = 'eth',
  eth_usdt = 'eth_usdt',
  wat = 'wat'
}

/**
 * The ReadPreference enum type is used in queries in order to select in which database replica the operation must run.
 */
export enum GQLReadPreference {
  NEAREST = 'NEAREST',
  PRIMARY = 'PRIMARY',
  PRIMARY_PREFERRED = 'PRIMARY_PREFERRED',
  SECONDARY = 'SECONDARY',
  SECONDARY_PREFERRED = 'SECONDARY_PREFERRED'
}

/**
 * The RoleOrder input type is used when sorting objects of the Role class.
 */
export enum GQLRoleOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  name_ASC = 'name_ASC',
  name_DESC = 'name_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  roles_ASC = 'roles_ASC',
  roles_DESC = 'roles_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  users_ASC = 'users_ASC',
  users_DESC = 'users_DESC'
}

/**
 * The SessionOrder input type is used when sorting objects of the Session class.
 */
export enum GQLSessionOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  createdWith_ASC = 'createdWith_ASC',
  createdWith_DESC = 'createdWith_DESC',
  expiresAt_ASC = 'expiresAt_ASC',
  expiresAt_DESC = 'expiresAt_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  installationId_ASC = 'installationId_ASC',
  installationId_DESC = 'installationId_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  sessionToken_ASC = 'sessionToken_ASC',
  sessionToken_DESC = 'sessionToken_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  user_ASC = 'user_ASC',
  user_DESC = 'user_DESC'
}

/**
 * The UserOrder input type is used when sorting objects of the User class.
 */
export enum GQLUserOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  address_ASC = 'address_ASC',
  address_DESC = 'address_DESC',
  authData_ASC = 'authData_ASC',
  authData_DESC = 'authData_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  emailVerified_ASC = 'emailVerified_ASC',
  emailVerified_DESC = 'emailVerified_DESC',
  email_ASC = 'email_ASC',
  email_DESC = 'email_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  isVerified_ASC = 'isVerified_ASC',
  isVerified_DESC = 'isVerified_DESC',
  kycData_ASC = 'kycData_ASC',
  kycData_DESC = 'kycData_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  password_ASC = 'password_ASC',
  password_DESC = 'password_DESC',
  sessionId_ASC = 'sessionId_ASC',
  sessionId_DESC = 'sessionId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  stripeId_ASC = 'stripeId_ASC',
  stripeId_DESC = 'stripeId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  username_ASC = 'username_ASC',
  username_DESC = 'username_DESC',
  verificationDate_ASC = 'verificationDate_ASC',
  verificationDate_DESC = 'verificationDate_DESC'
}

export enum GQLUserStatuses {
  active = 'active',
  blocked = 'blocked',
  new = 'new'
}

/**
 * The ValidatorOrder input type is used when sorting objects of the Validator class.
 */
export enum GQLValidatorOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Instance_ASC = 'Instance_ASC',
  Instance_DESC = 'Instance_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  activationDate_ASC = 'activationDate_ASC',
  activationDate_DESC = 'activationDate_DESC',
  coordinatorBalance_ASC = 'coordinatorBalance_ASC',
  coordinatorBalance_DESC = 'coordinatorBalance_DESC',
  coordinatorPublicKey_ASC = 'coordinatorPublicKey_ASC',
  coordinatorPublicKey_DESC = 'coordinatorPublicKey_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  depositData_ASC = 'depositData_ASC',
  depositData_DESC = 'depositData_DESC',
  depositSent_ASC = 'depositSent_ASC',
  depositSent_DESC = 'depositSent_DESC',
  depositTx_ASC = 'depositTx_ASC',
  depositTx_DESC = 'depositTx_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  index_ASC = 'index_ASC',
  index_DESC = 'index_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  type_ASC = 'type_ASC',
  type_DESC = 'type_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  validatorBalance_ASC = 'validatorBalance_ASC',
  validatorBalance_DESC = 'validatorBalance_DESC',
  validatorPublicKey_ASC = 'validatorPublicKey_ASC',
  validatorPublicKey_DESC = 'validatorPublicKey_DESC'
}

/**
 * The ValidatorPaymentOrder input type is used when sorting objects of the ValidatorPayment class.
 */
export enum GQLValidatorPaymentOrder {
  ACL_ASC = 'ACL_ASC',
  ACL_DESC = 'ACL_DESC',
  Instance_ASC = 'Instance_ASC',
  Instance_DESC = 'Instance_DESC',
  User_ASC = 'User_ASC',
  User_DESC = 'User_DESC',
  Validators_ASC = 'Validators_ASC',
  Validators_DESC = 'Validators_DESC',
  amount_ASC = 'amount_ASC',
  amount_DESC = 'amount_DESC',
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  error_ASC = 'error_ASC',
  error_DESC = 'error_DESC',
  id_ASC = 'id_ASC',
  id_DESC = 'id_DESC',
  network_ASC = 'network_ASC',
  network_DESC = 'network_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  outerId_ASC = 'outerId_ASC',
  outerId_DESC = 'outerId_DESC',
  status_ASC = 'status_ASC',
  status_DESC = 'status_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC'
}

export enum GQL_SessionOrder {
  createdAt_ASC = 'createdAt_ASC',
  createdAt_DESC = 'createdAt_DESC',
  expiresAt_ASC = 'expiresAt_ASC',
  expiresAt_DESC = 'expiresAt_DESC',
  objectId_ASC = 'objectId_ASC',
  objectId_DESC = 'objectId_DESC',
  updatedAt_ASC = 'updatedAt_ASC',
  updatedAt_DESC = 'updatedAt_DESC',
  user_ASC = 'user_ASC',
  user_DESC = 'user_DESC'
}

/**
 * The Any scalar type is used in operations and types that involve any type of value.
 */
export type GQLAny = any;

/**
 * The Bytes scalar type is used in operations and types that involve base 64 binary data.
 */
export type GQLBytes = any;

/**
 * The Date scalar type is used in operations and types that involve dates.
 */
export type GQLDate = any;

/**
 * The File scalar type is used in operations and types that involve files.
 */
export type GQLFile = any;

/**
 * The Object scalar type is used in operations and types that involve objects.
 */
export type GQLObject = any;

/**
 * The Upload scalar type represents a file upload.
 */
export type GQLUpload = any;

/**
 * Allow to manage access rights. If not provided object will be publicly readable and writable
 */
export interface GQLACLInput {
  
  /**
   * Public access control list.
   */
  public?: GQLPublicACLInput;
  
  /**
   * Access control list for roles.
   */
  roles?: Array<GQLRoleACLInput>;
  
  /**
   * Access control list for users.
   */
  users?: Array<GQLUserACLInput>;
}

export interface GQLAddCardToUserInp {
  cardNumber: string;
  cvc: string;
  expiryDate: string;
  nameOnCard?: string;
}

export interface GQLAddFileInput {
  contentType: string;
  imgBuff: string;
  name: string;
  type: GQLFileType;
}

export interface GQLAddValidatorInp {
  card?: GQLAddCardToUserInp;
  cardId?: string;
  datacenter: string;
  outerId: string;
  paymentMethod: GQLPaymentMethod;
  regionId: string;
  zoneName: string;
}

export interface GQLAdminCreateUserFieldsInput {
  email: string;
  emailVerified?: boolean;
  password: string;
  roles?: GQLRoleRelationInput;
  status?: GQLUserStatuses;
  username: string;
}

export interface GQLAdminCreateUserInput {
  clientMutationId?: string;
  fields?: GQLAdminCreateUserFieldsInput;
}

export interface GQLAdminDeleteUserInput {
  clientMutationId?: string;
  id: string;
}

export interface GQLAdminUpdateUserFieldsInput {
  email?: string;
  emailVerified?: boolean;
  password?: string;
  roles?: GQLRoleRelationInput;
  status?: GQLUserStatuses;
  username?: string;
}

export interface GQLAdminUpdateUserInput {
  clientMutationId?: string;
  fields: GQLAdminUpdateUserFieldsInput;
  id: string;
}

/**
 * Allow to link OR add and link an object of the AppFile class.
 */
export interface GQLAppFilePointerInput {
  
  /**
   * Create and link an object from AppFile class.
   */
  createAndLink?: GQLCreateAppFileFieldsInput;
  
  /**
   * Link an existing object from AppFile class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the AppFile class into a relation field.
 */
export interface GQLAppFileRelationInput {
  
  /**
   * Add existing objects from the AppFile class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the AppFile class into the relation.
   */
  createAndAdd?: Array<GQLCreateAppFileFieldsInput>;
  
  /**
   * Remove existing objects from the AppFile class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The AppFileRelationWhereInput input type is used in operations that involve filtering objects of AppFile class.
 */
export interface GQLAppFileRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLAppFileWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLAppFileWhereInput;
}

/**
 * The AppFileWhereInput input type is used in operations that involve filtering objects of AppFile class.
 */
export interface GQLAppFileWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLAppFileWhereInput>;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstanceRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLAppFileWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLAppFileWhereInput>;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object file.
   */
  file?: GQLFileWhereInput;
  
  /**
   * This is the object filePath.
   */
  filePath?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object info.
   */
  info?: GQLObjectWhereInput;
  
  /**
   * This is the object isResized.
   */
  isResized?: GQLBooleanWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The ArrayWhereInput input type is used in operations that involve filtering objects by a field of type Array.
 */
export interface GQLArrayWhereInput {
  
  /**
   * This is the containedBy operator to specify a constraint to select the objects where the values of an array field is contained by another specified array.
   */
  containedBy?: Array<GQLAny | null>;
  
  /**
   * This is the contains operator to specify a constraint to select the objects where the values of an array field contain all elements of another specified array.
   */
  contains?: Array<GQLAny | null>;
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLAny;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLAny;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLAny;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLAny | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLAny;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLAny;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLAny;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLAny | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * Allow to link OR add and link an object of the AuthMetamask class.
 */
export interface GQLAuthMetamaskPointerInput {
  
  /**
   * Create and link an object from AuthMetamask class.
   */
  createAndLink?: GQLCreateAuthMetamaskFieldsInput;
  
  /**
   * Link an existing object from AuthMetamask class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the AuthMetamask class into a relation field.
 */
export interface GQLAuthMetamaskRelationInput {
  
  /**
   * Add existing objects from the AuthMetamask class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the AuthMetamask class into the relation.
   */
  createAndAdd?: Array<GQLCreateAuthMetamaskFieldsInput>;
  
  /**
   * Remove existing objects from the AuthMetamask class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The AuthMetamaskRelationWhereInput input type is used in operations that involve filtering objects of AuthMetamask class.
 */
export interface GQLAuthMetamaskRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLAuthMetamaskWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLAuthMetamaskWhereInput;
}

/**
 * The AuthMetamaskWhereInput input type is used in operations that involve filtering objects of AuthMetamask class.
 */
export interface GQLAuthMetamaskWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLAuthMetamaskWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLAuthMetamaskWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLAuthMetamaskWhereInput>;
  
  /**
   * This is the object address.
   */
  address?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * The BooleanWhereInput input type is used in operations that involve filtering objects by a field of type Boolean.
 */
export interface GQLBooleanWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: boolean;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: boolean;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * The BoxInput type is used to specifiy a box operation on a within geo query.
 */
export interface GQLBoxInput {
  
  /**
   * This is the bottom left coordinates of the box.
   */
  bottomLeft: GQLGeoPointInput;
  
  /**
   * This is the upper right coordinates of the box.
   */
  upperRight: GQLGeoPointInput;
}

/**
 * The BytesWhereInput input type is used in operations that involve filtering objects by a field of type Bytes.
 */
export interface GQLBytesWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLBytes;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLBytes;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLBytes;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLBytes | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLBytes;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLBytes;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLBytes;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLBytes | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

export interface GQLCallCloudCodeInput {
  clientMutationId?: string;
  
  /**
   * This is the function to be called.
   */
  functionName: GQLCloudCodeFunction;
  
  /**
   * These are the params to be passed to the function.
   */
  params?: GQLObject;
}

export interface GQLCardIdInp {
  cardId: string;
}

/**
 * The CenterSphereInput type is used to specifiy a centerSphere operation on a geoWithin query.
 */
export interface GQLCenterSphereInput {
  
  /**
   * This is the center of the sphere.
   */
  center: GQLGeoPointInput;
  
  /**
   * This is the radius of the sphere.
   */
  distance: number;
}

export interface GQLChallengeInput {
  
  /**
   * Auth data allow to preidentify the user if the auth adapter needs preidentification.
   */
  authData?: GQLObject;
  
  /**
   * Challenge data payload, can be used to post data to auth providers to auth providers if they need data for the response.
   */
  challengeData?: GQLObject;
  clientMutationId?: string;
  
  /**
   * This is the password used to log in the user.
   */
  password?: string;
  
  /**
   * This is the username used to log in the user.
   */
  username?: string;
}

export interface GQLChangePasswordInput {
  clientMutationId?: string;
  id: string;
  password: string;
  token: string;
}

export interface GQLConfirmResetPasswordInput {
  clientMutationId?: string;
  password: string;
  token: string;
  username: string;
}

/**
 * The CreateAppFileFieldsInput input type is used in operations that involve creation of objects in the AppFile class.
 */
export interface GQLCreateAppFileFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object file.
   */
  file?: GQLFileInput;
  
  /**
   * This is the object filePath.
   */
  filePath?: string;
  
  /**
   * This is the object info.
   */
  info?: GQLObject;
  
  /**
   * This is the object isResized.
   */
  isResized?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLCreateAppFileInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateAppFileFieldsInput;
}

/**
 * The CreateAuthMetamaskFieldsInput input type is used in operations that involve creation of objects in the AuthMetamask class.
 */
export interface GQLCreateAuthMetamaskFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object address.
   */
  address?: string;
}

export interface GQLCreateAuthMetamaskInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateAuthMetamaskFieldsInput;
}

export interface GQLCreateClassInput {
  clientMutationId?: string;
  
  /**
   * This is the name of the object class.
   */
  name: string;
  
  /**
   * These are the schema's fields of the object class.
   */
  schemaFields?: GQLSchemaFieldsInput;
}

export interface GQLCreateFileInput {
  clientMutationId?: string;
  
  /**
   * This is the new file to be created and uploaded.
   */
  upload: GQLUpload;
}

/**
 * The CreateInstanceFieldsInput input type is used in operations that involve creation of objects in the Instance class.
 */
export interface GQLCreateInstanceFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object Validators.
   */
  Validators?: GQLValidatorRelationInput;
  
  /**
   * This is the object datacenter.
   */
  datacenter?: string;
  
  /**
   * This is the object instanceId.
   */
  instanceId?: string;
  
  /**
   * This is the object isSyncing.
   */
  isSyncing?: boolean;
  
  /**
   * This is the object privateIP.
   */
  privateIP?: string;
  
  /**
   * This is the object publicIP.
   */
  publicIP?: string;
  
  /**
   * This is the object region.
   */
  region?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object updateStatus.
   */
  updateStatus?: string;
  
  /**
   * This is the object zone.
   */
  zone?: string;
}

export interface GQLCreateInstanceInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateInstanceFieldsInput;
}

/**
 * The CreateInstancePaymentFieldsInput input type is used in operations that involve creation of objects in the InstancePayment class.
 */
export interface GQLCreateInstancePaymentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object Invoices.
   */
  Invoices?: GQLInvoiceRelationInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amount.
   */
  amount?: string;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object lastInvoice.
   */
  lastInvoice?: string;
  
  /**
   * This is the object paymentCheck.
   */
  paymentCheck?: GQLDate;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeCardId.
   */
  stripeCardId?: string;
  
  /**
   * This is the object stripeSubsId.
   */
  stripeSubsId?: string;
}

export interface GQLCreateInstancePaymentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateInstancePaymentFieldsInput;
}

/**
 * The CreateInvoiceFieldsInput input type is used in operations that involve creation of objects in the Invoice class.
 */
export interface GQLCreateInvoiceFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object InstancePayment.
   */
  InstancePayment?: GQLInstancePaymentPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object created.
   */
  created?: number;
  
  /**
   * This is the object currency.
   */
  currency?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object invoice_pdf.
   */
  invoice_pdf?: string;
  
  /**
   * This is the object number.
   */
  number?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object subscription.
   */
  subscription?: string;
  
  /**
   * This is the object total.
   */
  total?: number;
  
  /**
   * This is the object url.
   */
  url?: string;
}

export interface GQLCreateInvoiceInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateInvoiceFieldsInput;
}

/**
 * The CreateRoleFieldsInput input type is used in operations that involve creation of objects in the Role class.
 */
export interface GQLCreateRoleFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object roles.
   */
  roles?: GQLRoleRelationInput;
  
  /**
   * This is the object users.
   */
  users?: GQLUserRelationInput;
}

export interface GQLCreateRoleInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateRoleFieldsInput;
}

/**
 * The CreateSessionFieldsInput input type is used in operations that involve creation of objects in the Session class.
 */
export interface GQLCreateSessionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObject;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDate;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object user.
   */
  user?: GQLUserPointerInput;
}

export interface GQLCreateSessionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateSessionFieldsInput;
}

/**
 * The CreateUserFieldsInput input type is used in operations that involve creation of objects in the User class.
 */
export interface GQLCreateUserFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObject;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object kycData.
   */
  kycData?: GQLObject;
  
  /**
   * This is the object password.
   */
  password?: string;
  
  /**
   * This is the object sessionId.
   */
  sessionId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object username.
   */
  username?: string;
  
  /**
   * This is the object verificationDate.
   */
  verificationDate?: GQLDate;
}

export interface GQLCreateUserInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateUserFieldsInput;
}

/**
 * The CreateValidatorFieldsInput input type is used in operations that involve creation of objects in the Validator class.
 */
export interface GQLCreateValidatorFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object activationDate.
   */
  activationDate?: GQLDate;
  
  /**
   * This is the object coordinatorBalance.
   */
  coordinatorBalance?: string;
  
  /**
   * This is the object coordinatorPublicKey.
   */
  coordinatorPublicKey?: string;
  
  /**
   * This is the object depositData.
   */
  depositData?: GQLObject;
  
  /**
   * This is the object depositSent.
   */
  depositSent?: boolean;
  
  /**
   * This is the object depositTx.
   */
  depositTx?: GQLObject;
  
  /**
   * This is the object index.
   */
  index?: number;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object validatorBalance.
   */
  validatorBalance?: string;
  
  /**
   * This is the object validatorPublicKey.
   */
  validatorPublicKey?: string;
}

export interface GQLCreateValidatorInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateValidatorFieldsInput;
}

/**
 * The CreateValidatorPaymentFieldsInput input type is used in operations that involve creation of objects in the ValidatorPayment class.
 */
export interface GQLCreateValidatorPaymentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object Validators.
   */
  Validators?: GQLValidatorRelationInput;
  
  /**
   * This is the object amount.
   */
  amount?: string;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object network.
   */
  network?: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLCreateValidatorPaymentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to create the new object.
   */
  fields?: GQLCreateValidatorPaymentFieldsInput;
}

/**
 * The DateWhereInput input type is used in operations that involve filtering objects by a field of type Date.
 */
export interface GQLDateWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLDate;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLDate;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLDate;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLDate | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLDate;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLDate;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLDate;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLDate | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

export interface GQLDeleteAppFileInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteAuthMetamaskInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteClassInput {
  clientMutationId?: string;
  
  /**
   * This is the name of the object class.
   */
  name: string;
}

export interface GQLDeleteInstanceInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteInstancePaymentInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteInvoiceInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteRoleInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteSessionInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteUserInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteValidatorInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLDeleteValidatorPaymentInput {
  clientMutationId?: string;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * If this field is set to null the file will be unlinked (the file will not be deleted on cloud storage).
 */
export interface GQLFileInput {
  
  /**
   * A File Scalar can be an url or a FileInfo object.
   */
  file?: GQLFile;
  
  /**
   * Use this field if you want to create a new file.
   */
  upload?: GQLUpload;
}

/**
 * The FileWhereInput input type is used in operations that involve filtering objects by a field of type File.
 */
export interface GQLFileWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLFile;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLFile;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLFile;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLFile | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLFile;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLFile;
  
  /**
   * This is the matchesRegex operator to specify a constraint to select the objects where the value of a field matches a specified regular expression.
   */
  matchesRegex?: string;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLFile;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLFile | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
  
  /**
   * This is the options operator to specify optional flags (such as "i" and "m") to be added to a matchesRegex operation in the same set of constraints.
   */
  options?: string;
}

/**
 * The GeoIntersectsInput type is used to specify a geoIntersects operation on a constraint.
 */
export interface GQLGeoIntersectsInput {
  
  /**
   * This is the point to be specified.
   */
  point?: GQLGeoPointInput;
}

/**
 * The GeoPointInput type is used in operations that involve inputting fields of type geo point.
 */
export interface GQLGeoPointInput {
  
  /**
   * This is the latitude.
   */
  latitude: number;
  
  /**
   * This is the longitude.
   */
  longitude: number;
}

/**
 * The GeoPointWhereInput input type is used in operations that involve filtering objects by a field of type GeoPoint.
 */
export interface GQLGeoPointWhereInput {
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the geoWithin operator to specify a constraint to select the objects where the values of a geo point field is within a specified polygon or sphere.
   */
  geoWithin?: GQLGeoWithinInput;
  
  /**
   * This is the maxDistance operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in radians) from the geo point specified in the $nearSphere operator.
   */
  maxDistance?: number;
  
  /**
   * This is the maxDistanceInKilometers operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in kilometers) from the geo point specified in the $nearSphere operator.
   */
  maxDistanceInKilometers?: number;
  
  /**
   * This is the maxDistanceInMiles operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in miles) from the geo point specified in the $nearSphere operator.
   */
  maxDistanceInMiles?: number;
  
  /**
   * This is the maxDistanceInRadians operator to specify a constraint to select the objects where the values of a geo point field is at a max distance (in radians) from the geo point specified in the $nearSphere operator.
   */
  maxDistanceInRadians?: number;
  
  /**
   * This is the nearSphere operator to specify a constraint to select the objects where the values of a geo point field is near to another geo point.
   */
  nearSphere?: GQLGeoPointInput;
  
  /**
   * This is the within operator to specify a constraint to select the objects where the values of a geo point field is within a specified box.
   */
  within?: GQLWithinInput;
}

/**
 * The GeoWithinInput type is used to specify a geoWithin operation on a constraint.
 */
export interface GQLGeoWithinInput {
  
  /**
   * This is the sphere to be specified.
   */
  centerSphere?: GQLCenterSphereInput;
  
  /**
   * This is the polygon to be specified.
   */
  polygon?: Array<GQLGeoPointInput>;
}

export interface GQLGetAuthIdInput {
  address?: string;
}

export interface GQLGetUserCardsInp {
  userId?: string;
}

/**
 * The IdWhereInput input type is used in operations that involve filtering objects by an id.
 */
export interface GQLIdWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: string;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: string;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: string;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<string | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: string;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: string;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: string;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<string | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * Allow to link OR add and link an object of the InstancePayment class.
 */
export interface GQLInstancePaymentPointerInput {
  
  /**
   * Create and link an object from InstancePayment class.
   */
  createAndLink?: GQLCreateInstancePaymentFieldsInput;
  
  /**
   * Link an existing object from InstancePayment class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the InstancePayment class into a relation field.
 */
export interface GQLInstancePaymentRelationInput {
  
  /**
   * Add existing objects from the InstancePayment class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the InstancePayment class into the relation.
   */
  createAndAdd?: Array<GQLCreateInstancePaymentFieldsInput>;
  
  /**
   * Remove existing objects from the InstancePayment class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The InstancePaymentRelationWhereInput input type is used in operations that involve filtering objects of InstancePayment class.
 */
export interface GQLInstancePaymentRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLInstancePaymentWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLInstancePaymentWhereInput;
}

/**
 * The InstancePaymentWhereInput input type is used in operations that involve filtering objects of InstancePayment class.
 */
export interface GQLInstancePaymentWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLInstancePaymentWhereInput>;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstanceRelationWhereInput;
  
  /**
   * This is the object Invoices.
   */
  Invoices?: GQLInvoiceRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLInstancePaymentWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLInstancePaymentWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object amount.
   */
  amount?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object error.
   */
  error?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object lastInvoice.
   */
  lastInvoice?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object paymentCheck.
   */
  paymentCheck?: GQLDateWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object stripeCardId.
   */
  stripeCardId?: GQLStringWhereInput;
  
  /**
   * This is the object stripeSubsId.
   */
  stripeSubsId?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the Instance class.
 */
export interface GQLInstancePointerInput {
  
  /**
   * Create and link an object from Instance class.
   */
  createAndLink?: GQLCreateInstanceFieldsInput;
  
  /**
   * Link an existing object from Instance class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Instance class into a relation field.
 */
export interface GQLInstanceRelationInput {
  
  /**
   * Add existing objects from the Instance class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Instance class into the relation.
   */
  createAndAdd?: Array<GQLCreateInstanceFieldsInput>;
  
  /**
   * Remove existing objects from the Instance class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The InstanceRelationWhereInput input type is used in operations that involve filtering objects of Instance class.
 */
export interface GQLInstanceRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLInstanceWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLInstanceWhereInput;
}

/**
 * The InstanceWhereInput input type is used in operations that involve filtering objects of Instance class.
 */
export interface GQLInstanceWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLInstanceWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLInstanceWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLInstanceWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Validators.
   */
  Validators?: GQLValidatorRelationWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object datacenter.
   */
  datacenter?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object instanceId.
   */
  instanceId?: GQLStringWhereInput;
  
  /**
   * This is the object isSyncing.
   */
  isSyncing?: GQLBooleanWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object privateIP.
   */
  privateIP?: GQLStringWhereInput;
  
  /**
   * This is the object publicIP.
   */
  publicIP?: GQLStringWhereInput;
  
  /**
   * This is the object region.
   */
  region?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updateStatus.
   */
  updateStatus?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object zone.
   */
  zone?: GQLStringWhereInput;
}

/**
 * Allow to link OR add and link an object of the Invoice class.
 */
export interface GQLInvoicePointerInput {
  
  /**
   * Create and link an object from Invoice class.
   */
  createAndLink?: GQLCreateInvoiceFieldsInput;
  
  /**
   * Link an existing object from Invoice class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Invoice class into a relation field.
 */
export interface GQLInvoiceRelationInput {
  
  /**
   * Add existing objects from the Invoice class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Invoice class into the relation.
   */
  createAndAdd?: Array<GQLCreateInvoiceFieldsInput>;
  
  /**
   * Remove existing objects from the Invoice class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The InvoiceRelationWhereInput input type is used in operations that involve filtering objects of Invoice class.
 */
export interface GQLInvoiceRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLInvoiceWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLInvoiceWhereInput;
}

/**
 * The InvoiceWhereInput input type is used in operations that involve filtering objects of Invoice class.
 */
export interface GQLInvoiceWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLInvoiceWhereInput>;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstanceRelationWhereInput;
  
  /**
   * This is the object InstancePayment.
   */
  InstancePayment?: GQLInstancePaymentRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLInvoiceWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLInvoiceWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object created.
   */
  created?: GQLNumberWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object currency.
   */
  currency?: GQLStringWhereInput;
  
  /**
   * This is the object description.
   */
  description?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object invoice_pdf.
   */
  invoice_pdf?: GQLStringWhereInput;
  
  /**
   * This is the object number.
   */
  number?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: GQLStringWhereInput;
  
  /**
   * This is the object subscription.
   */
  subscription?: GQLStringWhereInput;
  
  /**
   * This is the object total.
   */
  total?: GQLNumberWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object url.
   */
  url?: GQLStringWhereInput;
}

/**
 * An entry from an object, i.e., a pair of key and value.
 */
export interface GQLKeyValueInput {
  
  /**
   * The key used to retrieve the value of this entry.
   */
  key: string;
  
  /**
   * The value of the entry. Could be any type of scalar data.
   */
  value: GQLAny;
}

export interface GQLLogInInput {
  
  /**
   * Auth data payload, needed if some required auth adapters are configured.
   */
  authData?: GQLObject;
  clientMutationId?: string;
  
  /**
   * This is the password used to log in the user.
   */
  password: string;
  
  /**
   * This is the username used to log in the user.
   */
  username: string;
}

export interface GQLLogInWithInput {
  authData: GQLObject;
  clientMutationId?: string;
  fields?: GQLUserLoginWithInput;
}

export interface GQLLogOutInput {
  clientMutationId?: string;
}

/**
 * The NumberWhereInput input type is used in operations that involve filtering objects by a field of type Number.
 */
export interface GQLNumberWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: number;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: number;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: number;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<number | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: number;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: number;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: number;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<number | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * The ObjectWhereInput input type is used in operations that involve filtering result by a field of type Object.
 */
export interface GQLObjectWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: GQLKeyValueInput;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: GQLKeyValueInput;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: GQLKeyValueInput;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<GQLKeyValueInput | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: GQLKeyValueInput;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: GQLKeyValueInput;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: GQLKeyValueInput;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<GQLKeyValueInput | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
}

/**
 * The PointerFieldInput is used to specify a field of type pointer for an object class schema.
 */
export interface GQLPointerFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

/**
 * The PolygonWhereInput input type is used in operations that involve filtering objects by a field of type Polygon.
 */
export interface GQLPolygonWhereInput {
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the geoIntersects operator to specify a constraint to select the objects where the values of a polygon field intersect a specified point.
   */
  geoIntersects?: GQLGeoIntersectsInput;
}

/**
 * Allow to manage public rights.
 */
export interface GQLPublicACLInput {
  
  /**
   * Allow anyone to read the current object.
   */
  read: boolean;
  
  /**
   * Allow anyone to write on the current object.
   */
  write: boolean;
}

/**
 * The ReadOptionsInputt type is used in queries in order to set the read preferences.
 */
export interface GQLReadOptionsInput {
  
  /**
   * The read preference for the queries to be executed to include fields.
   */
  includeReadPreference?: GQLReadPreference;
  
  /**
   * The read preference for the main query to be executed.
   */
  readPreference?: GQLReadPreference;
  
  /**
   * The read preference for the subqueries that may be required.
   */
  subqueryReadPreference?: GQLReadPreference;
}

export interface GQLRecurring {
  interval: GQLInterval;
  interval_count?: number;
  trial_period_days?: number;
}

/**
 * The RelationFieldInput is used to specify a field of type relation for an object class schema.
 */
export interface GQLRelationFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
  
  /**
   * This is the name of the target class for the field.
   */
  targetClassName: string;
}

export interface GQLResetPasswordInput {
  clientMutationId?: string;
  email: string;
}

/**
 * Allow to manage roles in ACL.
 */
export interface GQLRoleACLInput {
  
  /**
   * Allow users who are members of the role to read the current object.
   */
  read: boolean;
  
  /**
   * Name of the targetted Role.
   */
  roleName: string;
  
  /**
   * Allow users who are members of the role to write on the current object.
   */
  write: boolean;
}

/**
 * Allow to link OR add and link an object of the Role class.
 */
export interface GQLRolePointerInput {
  
  /**
   * Create and link an object from Role class.
   */
  createAndLink?: GQLCreateRoleFieldsInput;
  
  /**
   * Link an existing object from Role class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Role class into a relation field.
 */
export interface GQLRoleRelationInput {
  
  /**
   * Add existing objects from the Role class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Role class into the relation.
   */
  createAndAdd?: Array<GQLCreateRoleFieldsInput>;
  
  /**
   * Remove existing objects from the Role class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The RoleRelationWhereInput input type is used in operations that involve filtering objects of Role class.
 */
export interface GQLRoleRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLRoleWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLRoleWhereInput;
}

/**
 * The RoleWhereInput input type is used in operations that involve filtering objects of Role class.
 */
export interface GQLRoleWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLRoleWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLRoleWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLRoleWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object name.
   */
  name?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object roles.
   */
  roles?: GQLRoleRelationWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object users.
   */
  users?: GQLUserRelationWhereInput;
}

/**
 * The SchemaArrayFieldInput is used to specify a field of type array for an object class schema.
 */
export interface GQLSchemaArrayFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBooleanFieldInput is used to specify a field of type boolean for an object class schema.
 */
export interface GQLSchemaBooleanFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaBytesFieldInput is used to specify a field of type bytes for an object class schema.
 */
export interface GQLSchemaBytesFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaDateFieldInput is used to specify a field of type date for an object class schema.
 */
export interface GQLSchemaDateFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaFieldInput is used to specify a field of an object class schema.
 */
export interface GQLSchemaFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The CreateClassSchemaInput type is used to specify the schema for a new object class to be created.
 */
export interface GQLSchemaFieldsInput {
  
  /**
   * These are the Array fields to be added to the class schema.
   */
  addArrays?: Array<GQLSchemaArrayFieldInput>;
  
  /**
   * These are the Boolean fields to be added to the class schema.
   */
  addBooleans?: Array<GQLSchemaBooleanFieldInput>;
  
  /**
   * These are the Bytes fields to be added to the class schema.
   */
  addBytes?: Array<GQLSchemaBytesFieldInput>;
  
  /**
   * These are the Date fields to be added to the class schema.
   */
  addDates?: Array<GQLSchemaDateFieldInput>;
  
  /**
   * These are the File fields to be added to the class schema.
   */
  addFiles?: Array<GQLSchemaFileFieldInput>;
  
  /**
   * This is the Geo Point field to be added to the class schema. Currently it is supported only one GeoPoint field per Class.
   */
  addGeoPoint?: GQLSchemaGeoPointFieldInput;
  
  /**
   * These are the Number fields to be added to the class schema.
   */
  addNumbers?: Array<GQLSchemaNumberFieldInput>;
  
  /**
   * These are the Object fields to be added to the class schema.
   */
  addObjects?: Array<GQLSchemaObjectFieldInput>;
  
  /**
   * These are the Pointer fields to be added to the class schema.
   */
  addPointers?: Array<GQLPointerFieldInput>;
  
  /**
   * These are the Polygon fields to be added to the class schema.
   */
  addPolygons?: Array<GQLSchemaPolygonFieldInput>;
  
  /**
   * These are the Relation fields to be added to the class schema.
   */
  addRelations?: Array<GQLRelationFieldInput>;
  
  /**
   * These are the String fields to be added to the class schema.
   */
  addStrings?: Array<GQLSchemaStringFieldInput>;
  
  /**
   * These are the fields to be removed from the class schema.
   */
  remove?: Array<GQLSchemaFieldInput>;
}

/**
 * The SchemaFileFieldInput is used to specify a field of type file for an object class schema.
 */
export interface GQLSchemaFileFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaGeoPointFieldInput is used to specify a field of type geo point for an object class schema.
 */
export interface GQLSchemaGeoPointFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaNumberFieldInput is used to specify a field of type number for an object class schema.
 */
export interface GQLSchemaNumberFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaObjectFieldInput is used to specify a field of type object for an object class schema.
 */
export interface GQLSchemaObjectFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaPolygonFieldInput is used to specify a field of type polygon for an object class schema.
 */
export interface GQLSchemaPolygonFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SchemaStringFieldInput is used to specify a field of type string for an object class schema.
 */
export interface GQLSchemaStringFieldInput {
  
  /**
   * This is the field name.
   */
  name: string;
}

/**
 * The SearchInput type is used to specifiy a search operation on a full text search.
 */
export interface GQLSearchInput {
  
  /**
   * This is the flag to enable or disable case sensitive search.
   */
  caseSensitive?: boolean;
  
  /**
   * This is the flag to enable or disable diacritic sensitive search.
   */
  diacriticSensitive?: boolean;
  
  /**
   * This is the language to tetermine the list of stop words and the rules for tokenizer.
   */
  language?: string;
  
  /**
   * This is the term to be searched.
   */
  term: string;
}

/**
 * The SelectInput type is used to specify an inQueryKey or a notInQueryKey operation on a constraint.
 */
export interface GQLSelectInput {
  
  /**
   * This is the key in the result of the subquery that must match (not match) the field.
   */
  key: string;
  
  /**
   * This is the subquery to be executed.
   */
  query: GQLSubqueryInput;
}

export interface GQLSendVerificationEmailInput {
  clientMutationId?: string;
  email: string;
}

/**
 * Allow to link OR add and link an object of the Session class.
 */
export interface GQLSessionPointerInput {
  
  /**
   * Create and link an object from Session class.
   */
  createAndLink?: GQLCreateSessionFieldsInput;
  
  /**
   * Link an existing object from Session class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Session class into a relation field.
 */
export interface GQLSessionRelationInput {
  
  /**
   * Add existing objects from the Session class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Session class into the relation.
   */
  createAndAdd?: Array<GQLCreateSessionFieldsInput>;
  
  /**
   * Remove existing objects from the Session class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The SessionRelationWhereInput input type is used in operations that involve filtering objects of Session class.
 */
export interface GQLSessionRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLSessionWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLSessionWhereInput;
}

/**
 * The SessionWhereInput input type is used in operations that involve filtering objects of Session class.
 */
export interface GQLSessionWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLSessionWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLSessionWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLSessionWhereInput>;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObjectWhereInput;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDateWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object installationId.
   */
  installationId?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object user.
   */
  user?: GQLUserRelationWhereInput;
}

export interface GQLSignUpInput {
  clientMutationId?: string;
  fields?: GQLCreateUserFieldsInput;
}

/**
 * The StringWhereInput input type is used in operations that involve filtering objects by a field of type String.
 */
export interface GQLStringWhereInput {
  
  /**
   * This is the equalTo operator to specify a constraint to select the objects where the value of a field equals to a specified value.
   */
  equalTo?: string;
  
  /**
   * This is the exists operator to specify a constraint to select the objects where a field exists (or do not exist).
   */
  exists?: boolean;
  
  /**
   * This is the greaterThan operator to specify a constraint to select the objects where the value of a field is greater than a specified value.
   */
  greaterThan?: string;
  
  /**
   * This is the greaterThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is greater than or equal to a specified value.
   */
  greaterThanOrEqualTo?: string;
  
  /**
   * This is the in operator to specify a constraint to select the objects where the value of a field equals any value in the specified array.
   */
  in?: Array<string | null>;
  
  /**
   * This is the inQueryKey operator to specify a constraint to select the objects where a field equals to a key in the result of a different query.
   */
  inQueryKey?: GQLSelectInput;
  
  /**
   * This is the lessThan operator to specify a constraint to select the objects where the value of a field is less than a specified value.
   */
  lessThan?: string;
  
  /**
   * This is the lessThanOrEqualTo operator to specify a constraint to select the objects where the value of a field is less than or equal to a specified value.
   */
  lessThanOrEqualTo?: string;
  
  /**
   * This is the matchesRegex operator to specify a constraint to select the objects where the value of a field matches a specified regular expression.
   */
  matchesRegex?: string;
  
  /**
   * This is the notEqualTo operator to specify a constraint to select the objects where the value of a field do not equal to a specified value.
   */
  notEqualTo?: string;
  
  /**
   * This is the notIn operator to specify a constraint to select the objects where the value of a field do not equal any value in the specified array.
   */
  notIn?: Array<string | null>;
  
  /**
   * This is the notInQueryKey operator to specify a constraint to select the objects where a field do not equal to a key in the result of a different query.
   */
  notInQueryKey?: GQLSelectInput;
  
  /**
   * This is the options operator to specify optional flags (such as "i" and "m") to be added to a matchesRegex operation in the same set of constraints.
   */
  options?: string;
  
  /**
   * This is the $text operator to specify a full text search constraint.
   */
  text?: GQLTextInput;
}

/**
 * The SubqueryInput type is used to specify a sub query to another class.
 */
export interface GQLSubqueryInput {
  
  /**
   * This is the class name of the object.
   */
  className: string;
  
  /**
   * These are the conditions that the objects need to match in order to be found
   */
  where: GQLObject;
}

/**
 * The TextInput type is used to specify a text operation on a constraint.
 */
export interface GQLTextInput {
  
  /**
   * This is the search to be executed.
   */
  search: GQLSearchInput;
}

/**
 * The UpdateAppFileFieldsInput input type is used in operations that involve creation of objects in the AppFile class.
 */
export interface GQLUpdateAppFileFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object Owner.
   */
  Owner?: GQLUserPointerInput;
  
  /**
   * This is the object file.
   */
  file?: GQLFileInput;
  
  /**
   * This is the object filePath.
   */
  filePath?: string;
  
  /**
   * This is the object info.
   */
  info?: GQLObject;
  
  /**
   * This is the object isResized.
   */
  isResized?: boolean;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
}

export interface GQLUpdateAppFileInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateAppFileFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateAuthMetamaskFieldsInput input type is used in operations that involve creation of objects in the AuthMetamask class.
 */
export interface GQLUpdateAuthMetamaskFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object address.
   */
  address?: string;
}

export interface GQLUpdateAuthMetamaskInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateAuthMetamaskFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

export interface GQLUpdateClassInput {
  clientMutationId?: string;
  
  /**
   * This is the name of the object class.
   */
  name: string;
  
  /**
   * These are the schema's fields of the object class.
   */
  schemaFields?: GQLSchemaFieldsInput;
}

/**
 * The UpdateInstanceFieldsInput input type is used in operations that involve creation of objects in the Instance class.
 */
export interface GQLUpdateInstanceFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object Validators.
   */
  Validators?: GQLValidatorRelationInput;
  
  /**
   * This is the object datacenter.
   */
  datacenter?: string;
  
  /**
   * This is the object instanceId.
   */
  instanceId?: string;
  
  /**
   * This is the object isSyncing.
   */
  isSyncing?: boolean;
  
  /**
   * This is the object privateIP.
   */
  privateIP?: string;
  
  /**
   * This is the object publicIP.
   */
  publicIP?: string;
  
  /**
   * This is the object region.
   */
  region?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object updateStatus.
   */
  updateStatus?: string;
  
  /**
   * This is the object zone.
   */
  zone?: string;
}

export interface GQLUpdateInstanceInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateInstanceFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateInstancePaymentFieldsInput input type is used in operations that involve creation of objects in the InstancePayment class.
 */
export interface GQLUpdateInstancePaymentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object Invoices.
   */
  Invoices?: GQLInvoiceRelationInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object amount.
   */
  amount?: string;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object lastInvoice.
   */
  lastInvoice?: string;
  
  /**
   * This is the object paymentCheck.
   */
  paymentCheck?: GQLDate;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeCardId.
   */
  stripeCardId?: string;
  
  /**
   * This is the object stripeSubsId.
   */
  stripeSubsId?: string;
}

export interface GQLUpdateInstancePaymentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateInstancePaymentFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateInvoiceFieldsInput input type is used in operations that involve creation of objects in the Invoice class.
 */
export interface GQLUpdateInvoiceFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object InstancePayment.
   */
  InstancePayment?: GQLInstancePaymentPointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object created.
   */
  created?: number;
  
  /**
   * This is the object currency.
   */
  currency?: string;
  
  /**
   * This is the object description.
   */
  description?: string;
  
  /**
   * This is the object invoice_pdf.
   */
  invoice_pdf?: string;
  
  /**
   * This is the object number.
   */
  number?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object subscription.
   */
  subscription?: string;
  
  /**
   * This is the object total.
   */
  total?: number;
  
  /**
   * This is the object url.
   */
  url?: string;
}

export interface GQLUpdateInvoiceInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateInvoiceFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateRoleFieldsInput input type is used in operations that involve creation of objects in the Role class.
 */
export interface GQLUpdateRoleFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object name.
   */
  name?: string;
  
  /**
   * This is the object roles.
   */
  roles?: GQLRoleRelationInput;
  
  /**
   * This is the object users.
   */
  users?: GQLUserRelationInput;
}

export interface GQLUpdateRoleInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateRoleFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateSessionFieldsInput input type is used in operations that involve creation of objects in the Session class.
 */
export interface GQLUpdateSessionFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object createdWith.
   */
  createdWith?: GQLObject;
  
  /**
   * This is the object expiresAt.
   */
  expiresAt?: GQLDate;
  
  /**
   * This is the object installationId.
   */
  installationId?: string;
  
  /**
   * This is the object sessionToken.
   */
  sessionToken?: string;
  
  /**
   * This is the object user.
   */
  user?: GQLUserPointerInput;
}

export interface GQLUpdateSessionInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateSessionFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateUserFieldsInput input type is used in operations that involve creation of objects in the User class.
 */
export interface GQLUpdateUserFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObject;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object kycData.
   */
  kycData?: GQLObject;
  
  /**
   * This is the object password.
   */
  password?: string;
  
  /**
   * This is the object sessionId.
   */
  sessionId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object username.
   */
  username?: string;
  
  /**
   * This is the object verificationDate.
   */
  verificationDate?: GQLDate;
}

export interface GQLUpdateUserInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateUserFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateValidatorFieldsInput input type is used in operations that involve creation of objects in the Validator class.
 */
export interface GQLUpdateValidatorFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object activationDate.
   */
  activationDate?: GQLDate;
  
  /**
   * This is the object coordinatorBalance.
   */
  coordinatorBalance?: string;
  
  /**
   * This is the object coordinatorPublicKey.
   */
  coordinatorPublicKey?: string;
  
  /**
   * This is the object depositData.
   */
  depositData?: GQLObject;
  
  /**
   * This is the object depositSent.
   */
  depositSent?: boolean;
  
  /**
   * This is the object depositTx.
   */
  depositTx?: GQLObject;
  
  /**
   * This is the object index.
   */
  index?: number;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object type.
   */
  type?: string;
  
  /**
   * This is the object validatorBalance.
   */
  validatorBalance?: string;
  
  /**
   * This is the object validatorPublicKey.
   */
  validatorPublicKey?: string;
}

export interface GQLUpdateValidatorInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateValidatorFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * The UpdateValidatorPaymentFieldsInput input type is used in operations that involve creation of objects in the ValidatorPayment class.
 */
export interface GQLUpdateValidatorPaymentFieldsInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstancePointerInput;
  
  /**
   * This is the object User.
   */
  User?: GQLUserPointerInput;
  
  /**
   * This is the object Validators.
   */
  Validators?: GQLValidatorRelationInput;
  
  /**
   * This is the object amount.
   */
  amount?: string;
  
  /**
   * This is the object error.
   */
  error?: string;
  
  /**
   * This is the object network.
   */
  network?: string;
  
  /**
   * This is the object outerId.
   */
  outerId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
}

export interface GQLUpdateValidatorPaymentInput {
  clientMutationId?: string;
  
  /**
   * These are the fields that will be used to update the object.
   */
  fields?: GQLUpdateValidatorPaymentFieldsInput;
  
  /**
   * This is the object id. You can use either the global or the object id.
   */
  id: string;
}

/**
 * Allow to manage users in ACL.
 */
export interface GQLUserACLInput {
  
  /**
   * Allow the user to read the current object.
   */
  read: boolean;
  
  /**
   * ID of the targetted User.
   */
  userId: string;
  
  /**
   * Allow the user to write on the current object.
   */
  write: boolean;
}

export interface GQLUserLoginWithInput {
  ACL?: GQLACLInput;
  
  /**
   * This is the object address.
   */
  address?: string;
  
  /**
   * This is the object email.
   */
  email?: string;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: boolean;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: boolean;
  
  /**
   * This is the object kycData.
   */
  kycData?: GQLObject;
  
  /**
   * This is the object sessionId.
   */
  sessionId?: string;
  
  /**
   * This is the object status.
   */
  status?: string;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: string;
  
  /**
   * This is the object verificationDate.
   */
  verificationDate?: GQLDate;
}

/**
 * Allow to link OR add and link an object of the User class.
 */
export interface GQLUserPointerInput {
  
  /**
   * Create and link an object from User class.
   */
  createAndLink?: GQLCreateUserFieldsInput;
  
  /**
   * Link an existing object from User class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the User class into a relation field.
 */
export interface GQLUserRelationInput {
  
  /**
   * Add existing objects from the User class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the User class into the relation.
   */
  createAndAdd?: Array<GQLCreateUserFieldsInput>;
  
  /**
   * Remove existing objects from the User class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The UserRelationWhereInput input type is used in operations that involve filtering objects of User class.
 */
export interface GQLUserRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLUserWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLUserWhereInput;
}

/**
 * The UserWhereInput input type is used in operations that involve filtering objects of User class.
 */
export interface GQLUserWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLUserWhereInput>;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLUserWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLUserWhereInput>;
  
  /**
   * This is the object address.
   */
  address?: GQLStringWhereInput;
  
  /**
   * This is the object authData.
   */
  authData?: GQLObjectWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object email.
   */
  email?: GQLStringWhereInput;
  
  /**
   * This is the object emailVerified.
   */
  emailVerified?: GQLBooleanWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object isVerified.
   */
  isVerified?: GQLBooleanWhereInput;
  
  /**
   * This is the object kycData.
   */
  kycData?: GQLObjectWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object password.
   */
  password?: GQLStringWhereInput;
  
  /**
   * This is the object sessionId.
   */
  sessionId?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object stripeId.
   */
  stripeId?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object username.
   */
  username?: GQLStringWhereInput;
  
  /**
   * This is the object verificationDate.
   */
  verificationDate?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the ValidatorPayment class.
 */
export interface GQLValidatorPaymentPointerInput {
  
  /**
   * Create and link an object from ValidatorPayment class.
   */
  createAndLink?: GQLCreateValidatorPaymentFieldsInput;
  
  /**
   * Link an existing object from ValidatorPayment class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the ValidatorPayment class into a relation field.
 */
export interface GQLValidatorPaymentRelationInput {
  
  /**
   * Add existing objects from the ValidatorPayment class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the ValidatorPayment class into the relation.
   */
  createAndAdd?: Array<GQLCreateValidatorPaymentFieldsInput>;
  
  /**
   * Remove existing objects from the ValidatorPayment class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ValidatorPaymentRelationWhereInput input type is used in operations that involve filtering objects of ValidatorPayment class.
 */
export interface GQLValidatorPaymentRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLValidatorPaymentWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLValidatorPaymentWhereInput;
}

/**
 * The ValidatorPaymentWhereInput input type is used in operations that involve filtering objects of ValidatorPayment class.
 */
export interface GQLValidatorPaymentWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLValidatorPaymentWhereInput>;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstanceRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLValidatorPaymentWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLValidatorPaymentWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object Validators.
   */
  Validators?: GQLValidatorRelationWhereInput;
  
  /**
   * This is the object amount.
   */
  amount?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object error.
   */
  error?: GQLStringWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object network.
   */
  network?: GQLStringWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object outerId.
   */
  outerId?: GQLStringWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
}

/**
 * Allow to link OR add and link an object of the Validator class.
 */
export interface GQLValidatorPointerInput {
  
  /**
   * Create and link an object from Validator class.
   */
  createAndLink?: GQLCreateValidatorFieldsInput;
  
  /**
   * Link an existing object from Validator class. You can use either the global or the object id.
   */
  link?: string;
}

/**
 * Allow to add, remove, createAndAdd objects of the Validator class into a relation field.
 */
export interface GQLValidatorRelationInput {
  
  /**
   * Add existing objects from the Validator class into the relation. You can use either the global or the object ids.
   */
  add?: Array<string>;
  
  /**
   * Create and add objects of the Validator class into the relation.
   */
  createAndAdd?: Array<GQLCreateValidatorFieldsInput>;
  
  /**
   * Remove existing objects from the Validator class out of the relation. You can use either the global or the object ids.
   */
  remove?: Array<string>;
}

/**
 * The ValidatorRelationWhereInput input type is used in operations that involve filtering objects of Validator class.
 */
export interface GQLValidatorRelationWhereInput {
  
  /**
   * Check if the relation/pointer contains objects.
   */
  exists?: boolean;
  
  /**
   * Run a relational/pointer query where at least one child object can match.
   */
  have?: GQLValidatorWhereInput;
  
  /**
   * Run an inverted relational/pointer query where at least one child object can match.
   */
  haveNot?: GQLValidatorWhereInput;
}

/**
 * The ValidatorWhereInput input type is used in operations that involve filtering objects of Validator class.
 */
export interface GQLValidatorWhereInput {
  
  /**
   * This is the object ACL.
   */
  ACL?: GQLObjectWhereInput;
  
  /**
   * This is the AND operator to compound constraints.
   */
  AND?: Array<GQLValidatorWhereInput>;
  
  /**
   * This is the object Instance.
   */
  Instance?: GQLInstanceRelationWhereInput;
  
  /**
   * This is the NOR operator to compound constraints.
   */
  NOR?: Array<GQLValidatorWhereInput>;
  
  /**
   * This is the OR operator to compound constraints.
   */
  OR?: Array<GQLValidatorWhereInput>;
  
  /**
   * This is the object User.
   */
  User?: GQLUserRelationWhereInput;
  
  /**
   * This is the object activationDate.
   */
  activationDate?: GQLDateWhereInput;
  
  /**
   * This is the object coordinatorBalance.
   */
  coordinatorBalance?: GQLStringWhereInput;
  
  /**
   * This is the object coordinatorPublicKey.
   */
  coordinatorPublicKey?: GQLStringWhereInput;
  
  /**
   * This is the object createdAt.
   */
  createdAt?: GQLDateWhereInput;
  
  /**
   * This is the object depositData.
   */
  depositData?: GQLObjectWhereInput;
  
  /**
   * This is the object depositSent.
   */
  depositSent?: GQLBooleanWhereInput;
  
  /**
   * This is the object depositTx.
   */
  depositTx?: GQLObjectWhereInput;
  
  /**
   * This is the object id.
   */
  id?: GQLIdWhereInput;
  
  /**
   * This is the object index.
   */
  index?: GQLNumberWhereInput;
  
  /**
   * This is the object objectId.
   */
  objectId?: GQLIdWhereInput;
  
  /**
   * This is the object status.
   */
  status?: GQLStringWhereInput;
  
  /**
   * This is the object type.
   */
  type?: GQLStringWhereInput;
  
  /**
   * This is the object updatedAt.
   */
  updatedAt?: GQLDateWhereInput;
  
  /**
   * This is the object validatorBalance.
   */
  validatorBalance?: GQLStringWhereInput;
  
  /**
   * This is the object validatorPublicKey.
   */
  validatorPublicKey?: GQLStringWhereInput;
}

export interface GQLVerifyEmailInput {
  clientMutationId?: string;
  id: string;
  token: string;
}

/**
 * The WithinInput type is used to specify a within operation on a constraint.
 */
export interface GQLWithinInput {
  
  /**
   * This is the box to be specified.
   */
  box: GQLBoxInput;
}

export interface GQLgetPaymentConfigInput {
  datacenter?: string;
  regionId?: string;
  zoneName?: string;
}

export interface GQLrepaySubscriptionInput {
  subId?: string;
}

/*********************************
 *                               *
 *         TYPE RESOLVERS        *
 *                               *
 *********************************/
/**
 * This interface define the shape of your resolver
 * Note that this type is designed to be compatible with graphql-tools resolvers
 * However, you can still use other generated interfaces to make your resolver type-safed
 */
export interface GQLResolver {
  Node?: {
    __resolveType: GQLNodeTypeResolver
  };
  
  ParseObject?: {
    __resolveType: GQLParseObjectTypeResolver
  };
  
  SchemaField?: {
    __resolveType: GQLSchemaFieldTypeResolver
  };
  
  ArrayResult?: {
    __resolveType: GQLArrayResultTypeResolver
  };
  
  ACL?: GQLACLTypeResolver;
  AddValidatorPayload?: GQLAddValidatorPayloadTypeResolver;
  AppFile?: GQLAppFileTypeResolver;
  AppFileConnection?: GQLAppFileConnectionTypeResolver;
  AppFileEdge?: GQLAppFileEdgeTypeResolver;
  AuthMetamask?: GQLAuthMetamaskTypeResolver;
  AuthMetamaskConnection?: GQLAuthMetamaskConnectionTypeResolver;
  AuthMetamaskEdge?: GQLAuthMetamaskEdgeTypeResolver;
  CallCloudCodePayload?: GQLCallCloudCodePayloadTypeResolver;
  CardInfoPayload?: GQLCardInfoPayloadTypeResolver;
  ChallengePayload?: GQLChallengePayloadTypeResolver;
  ChangePasswordPayload?: GQLChangePasswordPayloadTypeResolver;
  Class?: GQLClassTypeResolver;
  ConfirmResetPasswordPayload?: GQLConfirmResetPasswordPayloadTypeResolver;
  CreateAppFilePayload?: GQLCreateAppFilePayloadTypeResolver;
  CreateAuthMetamaskPayload?: GQLCreateAuthMetamaskPayloadTypeResolver;
  CreateClassPayload?: GQLCreateClassPayloadTypeResolver;
  CreateFilePayload?: GQLCreateFilePayloadTypeResolver;
  CreateInstancePayload?: GQLCreateInstancePayloadTypeResolver;
  CreateInstancePaymentPayload?: GQLCreateInstancePaymentPayloadTypeResolver;
  CreateInvoicePayload?: GQLCreateInvoicePayloadTypeResolver;
  CreateRolePayload?: GQLCreateRolePayloadTypeResolver;
  CreateSessionPayload?: GQLCreateSessionPayloadTypeResolver;
  CreateUserPayload?: GQLCreateUserPayloadTypeResolver;
  CreateValidatorPayload?: GQLCreateValidatorPayloadTypeResolver;
  CreateValidatorPaymentPayload?: GQLCreateValidatorPaymentPayloadTypeResolver;
  DeleteAppFilePayload?: GQLDeleteAppFilePayloadTypeResolver;
  DeleteAuthMetamaskPayload?: GQLDeleteAuthMetamaskPayloadTypeResolver;
  DeleteClassPayload?: GQLDeleteClassPayloadTypeResolver;
  DeleteInstancePayload?: GQLDeleteInstancePayloadTypeResolver;
  DeleteInstancePaymentPayload?: GQLDeleteInstancePaymentPayloadTypeResolver;
  DeleteInvoicePayload?: GQLDeleteInvoicePayloadTypeResolver;
  DeleteRolePayload?: GQLDeleteRolePayloadTypeResolver;
  DeleteSessionPayload?: GQLDeleteSessionPayloadTypeResolver;
  DeleteUserPayload?: GQLDeleteUserPayloadTypeResolver;
  DeleteValidatorPayload?: GQLDeleteValidatorPayloadTypeResolver;
  DeleteValidatorPaymentPayload?: GQLDeleteValidatorPaymentPayloadTypeResolver;
  Element?: GQLElementTypeResolver;
  FileInfo?: GQLFileInfoTypeResolver;
  GeoPoint?: GQLGeoPointTypeResolver;
  GetAuthIdPayload?: GQLGetAuthIdPayloadTypeResolver;
  GetKYCTokenPayload?: GQLGetKYCTokenPayloadTypeResolver;
  GetRatesPayload?: GQLGetRatesPayloadTypeResolver;
  GetUserCardsPayload?: GQLGetUserCardsPayloadTypeResolver;
  Instance?: GQLInstanceTypeResolver;
  InstanceConnection?: GQLInstanceConnectionTypeResolver;
  InstanceEdge?: GQLInstanceEdgeTypeResolver;
  InstancePayment?: GQLInstancePaymentTypeResolver;
  InstancePaymentConnection?: GQLInstancePaymentConnectionTypeResolver;
  InstancePaymentEdge?: GQLInstancePaymentEdgeTypeResolver;
  Invoice?: GQLInvoiceTypeResolver;
  InvoiceConnection?: GQLInvoiceConnectionTypeResolver;
  InvoiceEdge?: GQLInvoiceEdgeTypeResolver;
  LogInPayload?: GQLLogInPayloadTypeResolver;
  LogInWithPayload?: GQLLogInWithPayloadTypeResolver;
  LogOutPayload?: GQLLogOutPayloadTypeResolver;
  Mutation?: GQLMutationTypeResolver;
  PageInfo?: GQLPageInfoTypeResolver;
  PaymentConfig?: GQLPaymentConfigTypeResolver;
  PublicACL?: GQLPublicACLTypeResolver;
  Query?: GQLQueryTypeResolver;
  Rate?: GQLRateTypeResolver;
  Region?: GQLRegionTypeResolver;
  ResetPasswordPayload?: GQLResetPasswordPayloadTypeResolver;
  Role?: GQLRoleTypeResolver;
  RoleACL?: GQLRoleACLTypeResolver;
  RoleConnection?: GQLRoleConnectionTypeResolver;
  RoleEdge?: GQLRoleEdgeTypeResolver;
  SchemaACLField?: GQLSchemaACLFieldTypeResolver;
  SchemaArrayField?: GQLSchemaArrayFieldTypeResolver;
  SchemaBooleanField?: GQLSchemaBooleanFieldTypeResolver;
  SchemaBytesField?: GQLSchemaBytesFieldTypeResolver;
  SchemaDateField?: GQLSchemaDateFieldTypeResolver;
  SchemaFileField?: GQLSchemaFileFieldTypeResolver;
  SchemaGeoPointField?: GQLSchemaGeoPointFieldTypeResolver;
  SchemaNumberField?: GQLSchemaNumberFieldTypeResolver;
  SchemaObjectField?: GQLSchemaObjectFieldTypeResolver;
  SchemaPointerField?: GQLSchemaPointerFieldTypeResolver;
  SchemaPolygonField?: GQLSchemaPolygonFieldTypeResolver;
  SchemaRelationField?: GQLSchemaRelationFieldTypeResolver;
  SchemaStringField?: GQLSchemaStringFieldTypeResolver;
  SendVerificationEmailPayload?: GQLSendVerificationEmailPayloadTypeResolver;
  Session?: GQLSessionTypeResolver;
  SessionConnection?: GQLSessionConnectionTypeResolver;
  SessionEdge?: GQLSessionEdgeTypeResolver;
  SignUpPayload?: GQLSignUpPayloadTypeResolver;
  UpdateAppFilePayload?: GQLUpdateAppFilePayloadTypeResolver;
  UpdateAuthMetamaskPayload?: GQLUpdateAuthMetamaskPayloadTypeResolver;
  UpdateClassPayload?: GQLUpdateClassPayloadTypeResolver;
  UpdateInstancePayload?: GQLUpdateInstancePayloadTypeResolver;
  UpdateInstancePaymentPayload?: GQLUpdateInstancePaymentPayloadTypeResolver;
  UpdateInvoicePayload?: GQLUpdateInvoicePayloadTypeResolver;
  UpdateRolePayload?: GQLUpdateRolePayloadTypeResolver;
  UpdateSessionPayload?: GQLUpdateSessionPayloadTypeResolver;
  UpdateUserPayload?: GQLUpdateUserPayloadTypeResolver;
  UpdateValidatorPayload?: GQLUpdateValidatorPayloadTypeResolver;
  UpdateValidatorPaymentPayload?: GQLUpdateValidatorPaymentPayloadTypeResolver;
  User?: GQLUserTypeResolver;
  UserACL?: GQLUserACLTypeResolver;
  UserConnection?: GQLUserConnectionTypeResolver;
  UserEdge?: GQLUserEdgeTypeResolver;
  Validator?: GQLValidatorTypeResolver;
  ValidatorConnection?: GQLValidatorConnectionTypeResolver;
  ValidatorEdge?: GQLValidatorEdgeTypeResolver;
  ValidatorPayment?: GQLValidatorPaymentTypeResolver;
  ValidatorPaymentConnection?: GQLValidatorPaymentConnectionTypeResolver;
  ValidatorPaymentEdge?: GQLValidatorPaymentEdgeTypeResolver;
  VerifyEmailPayload?: GQLVerifyEmailPayloadTypeResolver;
  Viewer?: GQLViewerTypeResolver;
  Zone?: GQLZoneTypeResolver;
  getPaymentConfigPayload?: GQLgetPaymentConfigPayloadTypeResolver;
  Any?: GraphQLScalarType;
  Bytes?: GraphQLScalarType;
  Date?: GraphQLScalarType;
  File?: GraphQLScalarType;
  Object?: GraphQLScalarType;
  Upload?: GraphQLScalarType;
}
export interface GQLNodeTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'AppFile' | 'AuthMetamask' | 'Instance' | 'InstancePayment' | 'Invoice' | 'Role' | 'Session' | 'User' | 'Validator' | 'ValidatorPayment' | Promise<'AppFile' | 'AuthMetamask' | 'Instance' | 'InstancePayment' | 'Invoice' | 'Role' | 'Session' | 'User' | 'Validator' | 'ValidatorPayment'>;
}
export interface GQLParseObjectTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'AppFile' | 'AuthMetamask' | 'Instance' | 'InstancePayment' | 'Invoice' | 'Role' | 'Session' | 'User' | 'Validator' | 'ValidatorPayment' | Promise<'AppFile' | 'AuthMetamask' | 'Instance' | 'InstancePayment' | 'Invoice' | 'Role' | 'Session' | 'User' | 'Validator' | 'ValidatorPayment'>;
}
export interface GQLSchemaFieldTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'SchemaACLField' | 'SchemaArrayField' | 'SchemaBooleanField' | 'SchemaBytesField' | 'SchemaDateField' | 'SchemaFileField' | 'SchemaGeoPointField' | 'SchemaNumberField' | 'SchemaObjectField' | 'SchemaPointerField' | 'SchemaPolygonField' | 'SchemaRelationField' | 'SchemaStringField' | Promise<'SchemaACLField' | 'SchemaArrayField' | 'SchemaBooleanField' | 'SchemaBytesField' | 'SchemaDateField' | 'SchemaFileField' | 'SchemaGeoPointField' | 'SchemaNumberField' | 'SchemaObjectField' | 'SchemaPointerField' | 'SchemaPolygonField' | 'SchemaRelationField' | 'SchemaStringField'>;
}
export interface GQLArrayResultTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'AppFile' | 'AuthMetamask' | 'Element' | 'Instance' | 'InstancePayment' | 'Invoice' | 'Role' | 'Session' | 'User' | 'Validator' | 'ValidatorPayment' | Promise<'AppFile' | 'AuthMetamask' | 'Element' | 'Instance' | 'InstancePayment' | 'Invoice' | 'Role' | 'Session' | 'User' | 'Validator' | 'ValidatorPayment'>;
}
export interface GQLACLTypeResolver<TParent = any> {
  public?: ACLToPublicResolver<TParent>;
  roles?: ACLToRolesResolver<TParent>;
  users?: ACLToUsersResolver<TParent>;
}

export interface ACLToPublicResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ACLToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ACLToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAddValidatorPayloadTypeResolver<TParent = any> {
  instanceId?: AddValidatorPayloadToInstanceIdResolver<TParent>;
  url?: AddValidatorPayloadToUrlResolver<TParent>;
}

export interface AddValidatorPayloadToInstanceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AddValidatorPayloadToUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAppFileTypeResolver<TParent = any> {
  ACL?: AppFileToACLResolver<TParent>;
  Instance?: AppFileToInstanceResolver<TParent>;
  Owner?: AppFileToOwnerResolver<TParent>;
  createdAt?: AppFileToCreatedAtResolver<TParent>;
  file?: AppFileToFileResolver<TParent>;
  filePath?: AppFileToFilePathResolver<TParent>;
  id?: AppFileToIdResolver<TParent>;
  info?: AppFileToInfoResolver<TParent>;
  isResized?: AppFileToIsResizedResolver<TParent>;
  name?: AppFileToNameResolver<TParent>;
  objectId?: AppFileToObjectIdResolver<TParent>;
  type?: AppFileToTypeResolver<TParent>;
  updatedAt?: AppFileToUpdatedAtResolver<TParent>;
}

export interface AppFileToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToOwnerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToFilePathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToIsResizedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAppFileConnectionTypeResolver<TParent = any> {
  count?: AppFileConnectionToCountResolver<TParent>;
  edges?: AppFileConnectionToEdgesResolver<TParent>;
  pageInfo?: AppFileConnectionToPageInfoResolver<TParent>;
}

export interface AppFileConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAppFileEdgeTypeResolver<TParent = any> {
  cursor?: AppFileEdgeToCursorResolver<TParent>;
  node?: AppFileEdgeToNodeResolver<TParent>;
}

export interface AppFileEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AppFileEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAuthMetamaskTypeResolver<TParent = any> {
  ACL?: AuthMetamaskToACLResolver<TParent>;
  address?: AuthMetamaskToAddressResolver<TParent>;
  createdAt?: AuthMetamaskToCreatedAtResolver<TParent>;
  id?: AuthMetamaskToIdResolver<TParent>;
  objectId?: AuthMetamaskToObjectIdResolver<TParent>;
  updatedAt?: AuthMetamaskToUpdatedAtResolver<TParent>;
}

export interface AuthMetamaskToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAuthMetamaskConnectionTypeResolver<TParent = any> {
  count?: AuthMetamaskConnectionToCountResolver<TParent>;
  edges?: AuthMetamaskConnectionToEdgesResolver<TParent>;
  pageInfo?: AuthMetamaskConnectionToPageInfoResolver<TParent>;
}

export interface AuthMetamaskConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAuthMetamaskEdgeTypeResolver<TParent = any> {
  cursor?: AuthMetamaskEdgeToCursorResolver<TParent>;
  node?: AuthMetamaskEdgeToNodeResolver<TParent>;
}

export interface AuthMetamaskEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AuthMetamaskEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCallCloudCodePayloadTypeResolver<TParent = any> {
  clientMutationId?: CallCloudCodePayloadToClientMutationIdResolver<TParent>;
  result?: CallCloudCodePayloadToResultResolver<TParent>;
}

export interface CallCloudCodePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CallCloudCodePayloadToResultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCardInfoPayloadTypeResolver<TParent = any> {
  address_zip?: CardInfoPayloadToAddress_zipResolver<TParent>;
  address_zip_check?: CardInfoPayloadToAddress_zip_checkResolver<TParent>;
  brand?: CardInfoPayloadToBrandResolver<TParent>;
  country?: CardInfoPayloadToCountryResolver<TParent>;
  customer?: CardInfoPayloadToCustomerResolver<TParent>;
  cvc_check?: CardInfoPayloadToCvc_checkResolver<TParent>;
  exp_month?: CardInfoPayloadToExp_monthResolver<TParent>;
  exp_year?: CardInfoPayloadToExp_yearResolver<TParent>;
  fingerprint?: CardInfoPayloadToFingerprintResolver<TParent>;
  funding?: CardInfoPayloadToFundingResolver<TParent>;
  id?: CardInfoPayloadToIdResolver<TParent>;
  last4?: CardInfoPayloadToLast4Resolver<TParent>;
  name?: CardInfoPayloadToNameResolver<TParent>;
  object?: CardInfoPayloadToObjectResolver<TParent>;
}

export interface CardInfoPayloadToAddress_zipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToAddress_zip_checkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToBrandResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToCountryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToCustomerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToCvc_checkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToExp_monthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToExp_yearResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToFingerprintResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToFundingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToLast4Resolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CardInfoPayloadToObjectResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChallengePayloadTypeResolver<TParent = any> {
  challengeData?: ChallengePayloadToChallengeDataResolver<TParent>;
  clientMutationId?: ChallengePayloadToClientMutationIdResolver<TParent>;
}

export interface ChallengePayloadToChallengeDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChallengePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLChangePasswordPayloadTypeResolver<TParent = any> {
  clientMutationId?: ChangePasswordPayloadToClientMutationIdResolver<TParent>;
  ok?: ChangePasswordPayloadToOkResolver<TParent>;
}

export interface ChangePasswordPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ChangePasswordPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLClassTypeResolver<TParent = any> {
  name?: ClassToNameResolver<TParent>;
  schemaFields?: ClassToSchemaFieldsResolver<TParent>;
}

export interface ClassToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ClassToSchemaFieldsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLConfirmResetPasswordPayloadTypeResolver<TParent = any> {
  clientMutationId?: ConfirmResetPasswordPayloadToClientMutationIdResolver<TParent>;
  ok?: ConfirmResetPasswordPayloadToOkResolver<TParent>;
}

export interface ConfirmResetPasswordPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ConfirmResetPasswordPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateAppFilePayloadTypeResolver<TParent = any> {
  appFile?: CreateAppFilePayloadToAppFileResolver<TParent>;
  clientMutationId?: CreateAppFilePayloadToClientMutationIdResolver<TParent>;
}

export interface CreateAppFilePayloadToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateAppFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateAuthMetamaskPayloadTypeResolver<TParent = any> {
  authMetamask?: CreateAuthMetamaskPayloadToAuthMetamaskResolver<TParent>;
  clientMutationId?: CreateAuthMetamaskPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateAuthMetamaskPayloadToAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateAuthMetamaskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateClassPayloadTypeResolver<TParent = any> {
  class?: CreateClassPayloadToClassResolver<TParent>;
  clientMutationId?: CreateClassPayloadToClientMutationIdResolver<TParent>;
}

export interface CreateClassPayloadToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateFilePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateFilePayloadToClientMutationIdResolver<TParent>;
  fileInfo?: CreateFilePayloadToFileInfoResolver<TParent>;
}

export interface CreateFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateFilePayloadToFileInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateInstancePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateInstancePayloadToClientMutationIdResolver<TParent>;
  instance?: CreateInstancePayloadToInstanceResolver<TParent>;
}

export interface CreateInstancePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateInstancePayloadToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateInstancePaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateInstancePaymentPayloadToClientMutationIdResolver<TParent>;
  instancePayment?: CreateInstancePaymentPayloadToInstancePaymentResolver<TParent>;
}

export interface CreateInstancePaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateInstancePaymentPayloadToInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateInvoicePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateInvoicePayloadToClientMutationIdResolver<TParent>;
  invoice?: CreateInvoicePayloadToInvoiceResolver<TParent>;
}

export interface CreateInvoicePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateInvoicePayloadToInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateRolePayloadToClientMutationIdResolver<TParent>;
  role?: CreateRolePayloadToRoleResolver<TParent>;
}

export interface CreateRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateRolePayloadToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateSessionPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateSessionPayloadToClientMutationIdResolver<TParent>;
  session?: CreateSessionPayloadToSessionResolver<TParent>;
}

export interface CreateSessionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateSessionPayloadToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateUserPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateUserPayloadToClientMutationIdResolver<TParent>;
  user?: CreateUserPayloadToUserResolver<TParent>;
}

export interface CreateUserPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateUserPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateValidatorPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateValidatorPayloadToClientMutationIdResolver<TParent>;
  validator?: CreateValidatorPayloadToValidatorResolver<TParent>;
}

export interface CreateValidatorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateValidatorPayloadToValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCreateValidatorPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: CreateValidatorPaymentPayloadToClientMutationIdResolver<TParent>;
  validatorPayment?: CreateValidatorPaymentPayloadToValidatorPaymentResolver<TParent>;
}

export interface CreateValidatorPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CreateValidatorPaymentPayloadToValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteAppFilePayloadTypeResolver<TParent = any> {
  appFile?: DeleteAppFilePayloadToAppFileResolver<TParent>;
  clientMutationId?: DeleteAppFilePayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteAppFilePayloadToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteAppFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteAuthMetamaskPayloadTypeResolver<TParent = any> {
  authMetamask?: DeleteAuthMetamaskPayloadToAuthMetamaskResolver<TParent>;
  clientMutationId?: DeleteAuthMetamaskPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteAuthMetamaskPayloadToAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteAuthMetamaskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteClassPayloadTypeResolver<TParent = any> {
  class?: DeleteClassPayloadToClassResolver<TParent>;
  clientMutationId?: DeleteClassPayloadToClientMutationIdResolver<TParent>;
}

export interface DeleteClassPayloadToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteInstancePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteInstancePayloadToClientMutationIdResolver<TParent>;
  instance?: DeleteInstancePayloadToInstanceResolver<TParent>;
}

export interface DeleteInstancePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteInstancePayloadToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteInstancePaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteInstancePaymentPayloadToClientMutationIdResolver<TParent>;
  instancePayment?: DeleteInstancePaymentPayloadToInstancePaymentResolver<TParent>;
}

export interface DeleteInstancePaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteInstancePaymentPayloadToInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteInvoicePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteInvoicePayloadToClientMutationIdResolver<TParent>;
  invoice?: DeleteInvoicePayloadToInvoiceResolver<TParent>;
}

export interface DeleteInvoicePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteInvoicePayloadToInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteRolePayloadToClientMutationIdResolver<TParent>;
  role?: DeleteRolePayloadToRoleResolver<TParent>;
}

export interface DeleteRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteRolePayloadToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteSessionPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteSessionPayloadToClientMutationIdResolver<TParent>;
  session?: DeleteSessionPayloadToSessionResolver<TParent>;
}

export interface DeleteSessionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteSessionPayloadToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteUserPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteUserPayloadToClientMutationIdResolver<TParent>;
  user?: DeleteUserPayloadToUserResolver<TParent>;
}

export interface DeleteUserPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteUserPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteValidatorPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteValidatorPayloadToClientMutationIdResolver<TParent>;
  validator?: DeleteValidatorPayloadToValidatorResolver<TParent>;
}

export interface DeleteValidatorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteValidatorPayloadToValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDeleteValidatorPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: DeleteValidatorPaymentPayloadToClientMutationIdResolver<TParent>;
  validatorPayment?: DeleteValidatorPaymentPayloadToValidatorPaymentResolver<TParent>;
}

export interface DeleteValidatorPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DeleteValidatorPaymentPayloadToValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElementTypeResolver<TParent = any> {
  value?: ElementToValueResolver<TParent>;
}

export interface ElementToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLFileInfoTypeResolver<TParent = any> {
  name?: FileInfoToNameResolver<TParent>;
  url?: FileInfoToUrlResolver<TParent>;
}

export interface FileInfoToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface FileInfoToUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGeoPointTypeResolver<TParent = any> {
  latitude?: GeoPointToLatitudeResolver<TParent>;
  longitude?: GeoPointToLongitudeResolver<TParent>;
}

export interface GeoPointToLatitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GeoPointToLongitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetAuthIdPayloadTypeResolver<TParent = any> {
  token?: GetAuthIdPayloadToTokenResolver<TParent>;
}

export interface GetAuthIdPayloadToTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetKYCTokenPayloadTypeResolver<TParent = any> {
  created?: GetKYCTokenPayloadToCreatedResolver<TParent>;
  expire?: GetKYCTokenPayloadToExpireResolver<TParent>;
  token?: GetKYCTokenPayloadToTokenResolver<TParent>;
  used?: GetKYCTokenPayloadToUsedResolver<TParent>;
}

export interface GetKYCTokenPayloadToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetKYCTokenPayloadToExpireResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetKYCTokenPayloadToTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetKYCTokenPayloadToUsedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetRatesPayloadTypeResolver<TParent = any> {
  rates?: GetRatesPayloadToRatesResolver<TParent>;
}

export interface GetRatesPayloadToRatesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLGetUserCardsPayloadTypeResolver<TParent = any> {
  cards?: GetUserCardsPayloadToCardsResolver<TParent>;
  defaultCardId?: GetUserCardsPayloadToDefaultCardIdResolver<TParent>;
}

export interface GetUserCardsPayloadToCardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GetUserCardsPayloadToDefaultCardIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstanceTypeResolver<TParent = any> {
  ACL?: InstanceToACLResolver<TParent>;
  User?: InstanceToUserResolver<TParent>;
  Validators?: InstanceToValidatorsResolver<TParent>;
  createdAt?: InstanceToCreatedAtResolver<TParent>;
  datacenter?: InstanceToDatacenterResolver<TParent>;
  id?: InstanceToIdResolver<TParent>;
  instanceId?: InstanceToInstanceIdResolver<TParent>;
  isSyncing?: InstanceToIsSyncingResolver<TParent>;
  objectId?: InstanceToObjectIdResolver<TParent>;
  privateIP?: InstanceToPrivateIPResolver<TParent>;
  publicIP?: InstanceToPublicIPResolver<TParent>;
  region?: InstanceToRegionResolver<TParent>;
  status?: InstanceToStatusResolver<TParent>;
  updateStatus?: InstanceToUpdateStatusResolver<TParent>;
  updatedAt?: InstanceToUpdatedAtResolver<TParent>;
  zone?: InstanceToZoneResolver<TParent>;
}

export interface InstanceToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToValidatorsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLValidatorOrder>;
  skip?: number;
  where?: GQLValidatorWhereInput;
}
export interface InstanceToValidatorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: InstanceToValidatorsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToDatacenterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToInstanceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToIsSyncingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToPrivateIPResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToPublicIPResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToRegionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToUpdateStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceToZoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstanceConnectionTypeResolver<TParent = any> {
  count?: InstanceConnectionToCountResolver<TParent>;
  edges?: InstanceConnectionToEdgesResolver<TParent>;
  pageInfo?: InstanceConnectionToPageInfoResolver<TParent>;
}

export interface InstanceConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstanceEdgeTypeResolver<TParent = any> {
  cursor?: InstanceEdgeToCursorResolver<TParent>;
  node?: InstanceEdgeToNodeResolver<TParent>;
}

export interface InstanceEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstanceEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstancePaymentTypeResolver<TParent = any> {
  ACL?: InstancePaymentToACLResolver<TParent>;
  Instance?: InstancePaymentToInstanceResolver<TParent>;
  Invoices?: InstancePaymentToInvoicesResolver<TParent>;
  User?: InstancePaymentToUserResolver<TParent>;
  amount?: InstancePaymentToAmountResolver<TParent>;
  createdAt?: InstancePaymentToCreatedAtResolver<TParent>;
  error?: InstancePaymentToErrorResolver<TParent>;
  id?: InstancePaymentToIdResolver<TParent>;
  lastInvoice?: InstancePaymentToLastInvoiceResolver<TParent>;
  objectId?: InstancePaymentToObjectIdResolver<TParent>;
  paymentCheck?: InstancePaymentToPaymentCheckResolver<TParent>;
  status?: InstancePaymentToStatusResolver<TParent>;
  stripeCardId?: InstancePaymentToStripeCardIdResolver<TParent>;
  stripeSubsId?: InstancePaymentToStripeSubsIdResolver<TParent>;
  updatedAt?: InstancePaymentToUpdatedAtResolver<TParent>;
}

export interface InstancePaymentToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToInvoicesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInvoiceOrder>;
  skip?: number;
  where?: GQLInvoiceWhereInput;
}
export interface InstancePaymentToInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: InstancePaymentToInvoicesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToLastInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToPaymentCheckResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToStripeCardIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToStripeSubsIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstancePaymentConnectionTypeResolver<TParent = any> {
  count?: InstancePaymentConnectionToCountResolver<TParent>;
  edges?: InstancePaymentConnectionToEdgesResolver<TParent>;
  pageInfo?: InstancePaymentConnectionToPageInfoResolver<TParent>;
}

export interface InstancePaymentConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInstancePaymentEdgeTypeResolver<TParent = any> {
  cursor?: InstancePaymentEdgeToCursorResolver<TParent>;
  node?: InstancePaymentEdgeToNodeResolver<TParent>;
}

export interface InstancePaymentEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InstancePaymentEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvoiceTypeResolver<TParent = any> {
  ACL?: InvoiceToACLResolver<TParent>;
  Instance?: InvoiceToInstanceResolver<TParent>;
  InstancePayment?: InvoiceToInstancePaymentResolver<TParent>;
  User?: InvoiceToUserResolver<TParent>;
  created?: InvoiceToCreatedResolver<TParent>;
  createdAt?: InvoiceToCreatedAtResolver<TParent>;
  currency?: InvoiceToCurrencyResolver<TParent>;
  description?: InvoiceToDescriptionResolver<TParent>;
  id?: InvoiceToIdResolver<TParent>;
  invoice_pdf?: InvoiceToInvoice_pdfResolver<TParent>;
  number?: InvoiceToNumberResolver<TParent>;
  objectId?: InvoiceToObjectIdResolver<TParent>;
  status?: InvoiceToStatusResolver<TParent>;
  stripeId?: InvoiceToStripeIdResolver<TParent>;
  subscription?: InvoiceToSubscriptionResolver<TParent>;
  total?: InvoiceToTotalResolver<TParent>;
  updatedAt?: InvoiceToUpdatedAtResolver<TParent>;
  url?: InvoiceToUrlResolver<TParent>;
}

export interface InvoiceToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToInvoice_pdfResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToNumberResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToStripeIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToSubscriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceToUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvoiceConnectionTypeResolver<TParent = any> {
  count?: InvoiceConnectionToCountResolver<TParent>;
  edges?: InvoiceConnectionToEdgesResolver<TParent>;
  pageInfo?: InvoiceConnectionToPageInfoResolver<TParent>;
}

export interface InvoiceConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLInvoiceEdgeTypeResolver<TParent = any> {
  cursor?: InvoiceEdgeToCursorResolver<TParent>;
  node?: InvoiceEdgeToNodeResolver<TParent>;
}

export interface InvoiceEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface InvoiceEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLogInPayloadTypeResolver<TParent = any> {
  clientMutationId?: LogInPayloadToClientMutationIdResolver<TParent>;
  viewer?: LogInPayloadToViewerResolver<TParent>;
}

export interface LogInPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LogInPayloadToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLogInWithPayloadTypeResolver<TParent = any> {
  clientMutationId?: LogInWithPayloadToClientMutationIdResolver<TParent>;
  viewer?: LogInWithPayloadToViewerResolver<TParent>;
}

export interface LogInWithPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LogInWithPayloadToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLogOutPayloadTypeResolver<TParent = any> {
  clientMutationId?: LogOutPayloadToClientMutationIdResolver<TParent>;
  ok?: LogOutPayloadToOkResolver<TParent>;
}

export interface LogOutPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LogOutPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLMutationTypeResolver<TParent = any> {
  addValidator?: MutationToAddValidatorResolver<TParent>;
  adminCreateUser?: MutationToAdminCreateUserResolver<TParent>;
  adminDeleteUser?: MutationToAdminDeleteUserResolver<TParent>;
  adminLogin?: MutationToAdminLoginResolver<TParent>;
  adminUpdateUser?: MutationToAdminUpdateUserResolver<TParent>;
  callCloudCode?: MutationToCallCloudCodeResolver<TParent>;
  challenge?: MutationToChallengeResolver<TParent>;
  changePassword?: MutationToChangePasswordResolver<TParent>;
  confirmResetPassword?: MutationToConfirmResetPasswordResolver<TParent>;
  createAppFile?: MutationToCreateAppFileResolver<TParent>;
  createAuthMetamask?: MutationToCreateAuthMetamaskResolver<TParent>;
  createClass?: MutationToCreateClassResolver<TParent>;
  createFile?: MutationToCreateFileResolver<TParent>;
  createInstance?: MutationToCreateInstanceResolver<TParent>;
  createInstancePayment?: MutationToCreateInstancePaymentResolver<TParent>;
  createInvoice?: MutationToCreateInvoiceResolver<TParent>;
  createRole?: MutationToCreateRoleResolver<TParent>;
  createSession?: MutationToCreateSessionResolver<TParent>;
  createUser?: MutationToCreateUserResolver<TParent>;
  createValidator?: MutationToCreateValidatorResolver<TParent>;
  createValidatorPayment?: MutationToCreateValidatorPaymentResolver<TParent>;
  deleteAppFile?: MutationToDeleteAppFileResolver<TParent>;
  deleteAuthMetamask?: MutationToDeleteAuthMetamaskResolver<TParent>;
  deleteClass?: MutationToDeleteClassResolver<TParent>;
  deleteInstance?: MutationToDeleteInstanceResolver<TParent>;
  deleteInstancePayment?: MutationToDeleteInstancePaymentResolver<TParent>;
  deleteInvoice?: MutationToDeleteInvoiceResolver<TParent>;
  deleteRole?: MutationToDeleteRoleResolver<TParent>;
  deleteSession?: MutationToDeleteSessionResolver<TParent>;
  deleteUser?: MutationToDeleteUserResolver<TParent>;
  deleteValidator?: MutationToDeleteValidatorResolver<TParent>;
  deleteValidatorPayment?: MutationToDeleteValidatorPaymentResolver<TParent>;
  geKYCToken?: MutationToGeKYCTokenResolver<TParent>;
  getAuthId?: MutationToGetAuthIdResolver<TParent>;
  getPaymentConfig?: MutationToGetPaymentConfigResolver<TParent>;
  getRates?: MutationToGetRatesResolver<TParent>;
  logIn?: MutationToLogInResolver<TParent>;
  logInWith?: MutationToLogInWithResolver<TParent>;
  logOut?: MutationToLogOutResolver<TParent>;
  paymentAddCard?: MutationToPaymentAddCardResolver<TParent>;
  paymentDeleteCard?: MutationToPaymentDeleteCardResolver<TParent>;
  paymentGetUserCards?: MutationToPaymentGetUserCardsResolver<TParent>;
  paymentSetDefaultCard?: MutationToPaymentSetDefaultCardResolver<TParent>;
  repaySubscription?: MutationToRepaySubscriptionResolver<TParent>;
  resetPassword?: MutationToResetPasswordResolver<TParent>;
  sendVerificationEmail?: MutationToSendVerificationEmailResolver<TParent>;
  signUp?: MutationToSignUpResolver<TParent>;
  updateAppFile?: MutationToUpdateAppFileResolver<TParent>;
  updateAuthMetamask?: MutationToUpdateAuthMetamaskResolver<TParent>;
  updateClass?: MutationToUpdateClassResolver<TParent>;
  updateInstance?: MutationToUpdateInstanceResolver<TParent>;
  updateInstancePayment?: MutationToUpdateInstancePaymentResolver<TParent>;
  updateInvoice?: MutationToUpdateInvoiceResolver<TParent>;
  updateRole?: MutationToUpdateRoleResolver<TParent>;
  updateSession?: MutationToUpdateSessionResolver<TParent>;
  updateUser?: MutationToUpdateUserResolver<TParent>;
  updateValidator?: MutationToUpdateValidatorResolver<TParent>;
  updateValidatorPayment?: MutationToUpdateValidatorPaymentResolver<TParent>;
  verifyEmail?: MutationToVerifyEmailResolver<TParent>;
}

export interface MutationToAddValidatorArgs {
  input: GQLAddValidatorInp;
}
export interface MutationToAddValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAddValidatorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminCreateUserArgs {
  input: GQLAdminCreateUserInput;
}
export interface MutationToAdminCreateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminCreateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminDeleteUserArgs {
  input: GQLAdminDeleteUserInput;
}
export interface MutationToAdminDeleteUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminDeleteUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminLoginArgs {
  input: GQLLogInInput;
}
export interface MutationToAdminLoginResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminLoginArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToAdminUpdateUserArgs {
  input: GQLAdminUpdateUserInput;
}
export interface MutationToAdminUpdateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToAdminUpdateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCallCloudCodeArgs {
  input: GQLCallCloudCodeInput;
}
export interface MutationToCallCloudCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCallCloudCodeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToChallengeArgs {
  input: GQLChallengeInput;
}
export interface MutationToChallengeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToChallengeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToChangePasswordArgs {
  input: GQLChangePasswordInput;
}
export interface MutationToChangePasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToChangePasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToConfirmResetPasswordArgs {
  input: GQLConfirmResetPasswordInput;
}
export interface MutationToConfirmResetPasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToConfirmResetPasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateAppFileArgs {
  input: GQLCreateAppFileInput;
}
export interface MutationToCreateAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateAuthMetamaskArgs {
  input: GQLCreateAuthMetamaskInput;
}
export interface MutationToCreateAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateAuthMetamaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateClassArgs {
  input: GQLCreateClassInput;
}
export interface MutationToCreateClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateFileArgs {
  input: GQLCreateFileInput;
}
export interface MutationToCreateFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateInstanceArgs {
  input: GQLCreateInstanceInput;
}
export interface MutationToCreateInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateInstanceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateInstancePaymentArgs {
  input: GQLCreateInstancePaymentInput;
}
export interface MutationToCreateInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateInstancePaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateInvoiceArgs {
  input: GQLCreateInvoiceInput;
}
export interface MutationToCreateInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateInvoiceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateRoleArgs {
  input: GQLCreateRoleInput;
}
export interface MutationToCreateRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateSessionArgs {
  input: GQLCreateSessionInput;
}
export interface MutationToCreateSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateUserArgs {
  input: GQLCreateUserInput;
}
export interface MutationToCreateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateValidatorArgs {
  input: GQLCreateValidatorInput;
}
export interface MutationToCreateValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateValidatorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToCreateValidatorPaymentArgs {
  input: GQLCreateValidatorPaymentInput;
}
export interface MutationToCreateValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToCreateValidatorPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteAppFileArgs {
  input: GQLDeleteAppFileInput;
}
export interface MutationToDeleteAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteAuthMetamaskArgs {
  input: GQLDeleteAuthMetamaskInput;
}
export interface MutationToDeleteAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteAuthMetamaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteClassArgs {
  input: GQLDeleteClassInput;
}
export interface MutationToDeleteClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteInstanceArgs {
  input: GQLDeleteInstanceInput;
}
export interface MutationToDeleteInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteInstanceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteInstancePaymentArgs {
  input: GQLDeleteInstancePaymentInput;
}
export interface MutationToDeleteInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteInstancePaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteInvoiceArgs {
  input: GQLDeleteInvoiceInput;
}
export interface MutationToDeleteInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteInvoiceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteRoleArgs {
  input: GQLDeleteRoleInput;
}
export interface MutationToDeleteRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteSessionArgs {
  input: GQLDeleteSessionInput;
}
export interface MutationToDeleteSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteUserArgs {
  input: GQLDeleteUserInput;
}
export interface MutationToDeleteUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteValidatorArgs {
  input: GQLDeleteValidatorInput;
}
export interface MutationToDeleteValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteValidatorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToDeleteValidatorPaymentArgs {
  input: GQLDeleteValidatorPaymentInput;
}
export interface MutationToDeleteValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToDeleteValidatorPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGeKYCTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetAuthIdArgs {
  input: GQLGetAuthIdInput;
}
export interface MutationToGetAuthIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetAuthIdArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetPaymentConfigArgs {
  input?: GQLgetPaymentConfigInput;
}
export interface MutationToGetPaymentConfigResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToGetPaymentConfigArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToGetRatesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLogInArgs {
  input: GQLLogInInput;
}
export interface MutationToLogInResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLogInArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLogInWithArgs {
  input: GQLLogInWithInput;
}
export interface MutationToLogInWithResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLogInWithArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToLogOutArgs {
  input: GQLLogOutInput;
}
export interface MutationToLogOutResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToLogOutArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentAddCardArgs {
  input: GQLAddCardToUserInp;
}
export interface MutationToPaymentAddCardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentAddCardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentDeleteCardArgs {
  input: GQLCardIdInp;
}
export interface MutationToPaymentDeleteCardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentDeleteCardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentGetUserCardsArgs {
  input: GQLGetUserCardsInp;
}
export interface MutationToPaymentGetUserCardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentGetUserCardsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToPaymentSetDefaultCardArgs {
  input: GQLCardIdInp;
}
export interface MutationToPaymentSetDefaultCardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToPaymentSetDefaultCardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToRepaySubscriptionArgs {
  input?: GQLrepaySubscriptionInput;
}
export interface MutationToRepaySubscriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToRepaySubscriptionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToResetPasswordArgs {
  input: GQLResetPasswordInput;
}
export interface MutationToResetPasswordResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToResetPasswordArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSendVerificationEmailArgs {
  input: GQLSendVerificationEmailInput;
}
export interface MutationToSendVerificationEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSendVerificationEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToSignUpArgs {
  input: GQLSignUpInput;
}
export interface MutationToSignUpResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToSignUpArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateAppFileArgs {
  input: GQLUpdateAppFileInput;
}
export interface MutationToUpdateAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateAuthMetamaskArgs {
  input: GQLUpdateAuthMetamaskInput;
}
export interface MutationToUpdateAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateAuthMetamaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateClassArgs {
  input: GQLUpdateClassInput;
}
export interface MutationToUpdateClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateInstanceArgs {
  input: GQLUpdateInstanceInput;
}
export interface MutationToUpdateInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateInstanceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateInstancePaymentArgs {
  input: GQLUpdateInstancePaymentInput;
}
export interface MutationToUpdateInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateInstancePaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateInvoiceArgs {
  input: GQLUpdateInvoiceInput;
}
export interface MutationToUpdateInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateInvoiceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateRoleArgs {
  input: GQLUpdateRoleInput;
}
export interface MutationToUpdateRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateSessionArgs {
  input: GQLUpdateSessionInput;
}
export interface MutationToUpdateSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateUserArgs {
  input: GQLUpdateUserInput;
}
export interface MutationToUpdateUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateValidatorArgs {
  input: GQLUpdateValidatorInput;
}
export interface MutationToUpdateValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateValidatorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToUpdateValidatorPaymentArgs {
  input: GQLUpdateValidatorPaymentInput;
}
export interface MutationToUpdateValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToUpdateValidatorPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface MutationToVerifyEmailArgs {
  input: GQLVerifyEmailInput;
}
export interface MutationToVerifyEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: MutationToVerifyEmailArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPageInfoTypeResolver<TParent = any> {
  endCursor?: PageInfoToEndCursorResolver<TParent>;
  hasNextPage?: PageInfoToHasNextPageResolver<TParent>;
  hasPreviousPage?: PageInfoToHasPreviousPageResolver<TParent>;
  startCursor?: PageInfoToStartCursorResolver<TParent>;
}

export interface PageInfoToEndCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasNextPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasPreviousPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToStartCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPaymentConfigTypeResolver<TParent = any> {
  address?: PaymentConfigToAddressResolver<TParent>;
  amount?: PaymentConfigToAmountResolver<TParent>;
  chainId?: PaymentConfigToChainIdResolver<TParent>;
  contract?: PaymentConfigToContractResolver<TParent>;
  countConfirmation?: PaymentConfigToCountConfirmationResolver<TParent>;
  label?: PaymentConfigToLabelResolver<TParent>;
  rpc?: PaymentConfigToRpcResolver<TParent>;
  symbol?: PaymentConfigToSymbolResolver<TParent>;
  value?: PaymentConfigToValueResolver<TParent>;
}

export interface PaymentConfigToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToChainIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToContractResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToCountConfirmationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToLabelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToRpcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToSymbolResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PaymentConfigToValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPublicACLTypeResolver<TParent = any> {
  read?: PublicACLToReadResolver<TParent>;
  write?: PublicACLToWriteResolver<TParent>;
}

export interface PublicACLToReadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PublicACLToWriteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLQueryTypeResolver<TParent = any> {
  appFile?: QueryToAppFileResolver<TParent>;
  appFiles?: QueryToAppFilesResolver<TParent>;
  authMetamask?: QueryToAuthMetamaskResolver<TParent>;
  authMetamasks?: QueryToAuthMetamasksResolver<TParent>;
  class?: QueryToClassResolver<TParent>;
  classes?: QueryToClassesResolver<TParent>;
  health?: QueryToHealthResolver<TParent>;
  instance?: QueryToInstanceResolver<TParent>;
  instancePayment?: QueryToInstancePaymentResolver<TParent>;
  instancePayments?: QueryToInstancePaymentsResolver<TParent>;
  instances?: QueryToInstancesResolver<TParent>;
  invoice?: QueryToInvoiceResolver<TParent>;
  invoices?: QueryToInvoicesResolver<TParent>;
  node?: QueryToNodeResolver<TParent>;
  role?: QueryToRoleResolver<TParent>;
  roles?: QueryToRolesResolver<TParent>;
  searchSessions?: QueryToSearchSessionsResolver<TParent>;
  session?: QueryToSessionResolver<TParent>;
  sessions?: QueryToSessionsResolver<TParent>;
  user?: QueryToUserResolver<TParent>;
  users?: QueryToUsersResolver<TParent>;
  validator?: QueryToValidatorResolver<TParent>;
  validatorPayment?: QueryToValidatorPaymentResolver<TParent>;
  validatorPayments?: QueryToValidatorPaymentsResolver<TParent>;
  validators?: QueryToValidatorsResolver<TParent>;
  viewer?: QueryToViewerResolver<TParent>;
}

export interface QueryToAppFileArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAppFileArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAppFilesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLAppFileOrder>;
  skip?: number;
  where?: GQLAppFileWhereInput;
}
export interface QueryToAppFilesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAppFilesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAuthMetamaskArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAuthMetamaskArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToAuthMetamasksArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLAuthMetamaskOrder>;
  skip?: number;
  where?: GQLAuthMetamaskWhereInput;
}
export interface QueryToAuthMetamasksResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToAuthMetamasksArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToClassArgs {
  name: string;
}
export interface QueryToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToClassArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToClassesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToHealthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInstanceArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInstanceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInstancePaymentArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInstancePaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInstancePaymentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInstancePaymentOrder>;
  skip?: number;
  where?: GQLInstancePaymentWhereInput;
}
export interface QueryToInstancePaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInstancePaymentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInstancesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInstanceOrder>;
  skip?: number;
  where?: GQLInstanceWhereInput;
}
export interface QueryToInstancesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInstancesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInvoiceArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInvoiceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToInvoicesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLInvoiceOrder>;
  skip?: number;
  where?: GQLInvoiceWhereInput;
}
export interface QueryToInvoicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToInvoicesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToNodeArgs {
  id: string;
}
export interface QueryToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToNodeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToRoleArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToRoleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToRolesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLRoleOrder>;
  skip?: number;
  where?: GQLRoleWhereInput;
}
export interface QueryToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToRolesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSearchSessionsArgs {
  after?: string;
  first?: number;
  order?: GQL_SessionOrder;
  where?: GQLSessionWhereInput;
}
export interface QueryToSearchSessionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSearchSessionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSessionArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSessionArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToSessionsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLSessionOrder>;
  skip?: number;
  where?: GQLSessionWhereInput;
}
export interface QueryToSessionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToSessionsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToUserArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToUserArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToUsersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface QueryToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToValidatorArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToValidatorArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToValidatorPaymentArgs {
  id: string;
  options?: GQLReadOptionsInput;
}
export interface QueryToValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToValidatorPaymentArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToValidatorPaymentsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLValidatorPaymentOrder>;
  skip?: number;
  where?: GQLValidatorPaymentWhereInput;
}
export interface QueryToValidatorPaymentsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToValidatorPaymentsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToValidatorsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLValidatorOrder>;
  skip?: number;
  where?: GQLValidatorWhereInput;
}
export interface QueryToValidatorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: QueryToValidatorsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface QueryToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRateTypeResolver<TParent = any> {
  datacenter?: RateToDatacenterResolver<TParent>;
  zones?: RateToZonesResolver<TParent>;
}

export interface RateToDatacenterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RateToZonesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRegionTypeResolver<TParent = any> {
  countWorker?: RegionToCountWorkerResolver<TParent>;
  id?: RegionToIdResolver<TParent>;
  name?: RegionToNameResolver<TParent>;
  priceAmount?: RegionToPriceAmountResolver<TParent>;
  priceId?: RegionToPriceIdResolver<TParent>;
  productId?: RegionToProductIdResolver<TParent>;
  workerPrices?: RegionToWorkerPricesResolver<TParent>;
}

export interface RegionToCountWorkerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RegionToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RegionToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RegionToPriceAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RegionToPriceIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RegionToProductIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RegionToWorkerPricesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLResetPasswordPayloadTypeResolver<TParent = any> {
  clientMutationId?: ResetPasswordPayloadToClientMutationIdResolver<TParent>;
  ok?: ResetPasswordPayloadToOkResolver<TParent>;
}

export interface ResetPasswordPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ResetPasswordPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleTypeResolver<TParent = any> {
  ACL?: RoleToACLResolver<TParent>;
  createdAt?: RoleToCreatedAtResolver<TParent>;
  id?: RoleToIdResolver<TParent>;
  name?: RoleToNameResolver<TParent>;
  objectId?: RoleToObjectIdResolver<TParent>;
  roles?: RoleToRolesResolver<TParent>;
  updatedAt?: RoleToUpdatedAtResolver<TParent>;
  users?: RoleToUsersResolver<TParent>;
}

export interface RoleToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToRolesArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLRoleOrder>;
  skip?: number;
  where?: GQLRoleWhereInput;
}
export interface RoleToRolesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RoleToRolesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleToUsersArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLUserOrder>;
  skip?: number;
  where?: GQLUserWhereInput;
}
export interface RoleToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RoleToUsersArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleACLTypeResolver<TParent = any> {
  read?: RoleACLToReadResolver<TParent>;
  roleName?: RoleACLToRoleNameResolver<TParent>;
  write?: RoleACLToWriteResolver<TParent>;
}

export interface RoleACLToReadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleACLToRoleNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleACLToWriteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleConnectionTypeResolver<TParent = any> {
  count?: RoleConnectionToCountResolver<TParent>;
  edges?: RoleConnectionToEdgesResolver<TParent>;
  pageInfo?: RoleConnectionToPageInfoResolver<TParent>;
}

export interface RoleConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoleEdgeTypeResolver<TParent = any> {
  cursor?: RoleEdgeToCursorResolver<TParent>;
  node?: RoleEdgeToNodeResolver<TParent>;
}

export interface RoleEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoleEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaACLFieldTypeResolver<TParent = any> {
  name?: SchemaACLFieldToNameResolver<TParent>;
}

export interface SchemaACLFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaArrayFieldTypeResolver<TParent = any> {
  name?: SchemaArrayFieldToNameResolver<TParent>;
}

export interface SchemaArrayFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaBooleanFieldTypeResolver<TParent = any> {
  name?: SchemaBooleanFieldToNameResolver<TParent>;
}

export interface SchemaBooleanFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaBytesFieldTypeResolver<TParent = any> {
  name?: SchemaBytesFieldToNameResolver<TParent>;
}

export interface SchemaBytesFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaDateFieldTypeResolver<TParent = any> {
  name?: SchemaDateFieldToNameResolver<TParent>;
}

export interface SchemaDateFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaFileFieldTypeResolver<TParent = any> {
  name?: SchemaFileFieldToNameResolver<TParent>;
}

export interface SchemaFileFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaGeoPointFieldTypeResolver<TParent = any> {
  name?: SchemaGeoPointFieldToNameResolver<TParent>;
}

export interface SchemaGeoPointFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaNumberFieldTypeResolver<TParent = any> {
  name?: SchemaNumberFieldToNameResolver<TParent>;
}

export interface SchemaNumberFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaObjectFieldTypeResolver<TParent = any> {
  name?: SchemaObjectFieldToNameResolver<TParent>;
}

export interface SchemaObjectFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaPointerFieldTypeResolver<TParent = any> {
  name?: SchemaPointerFieldToNameResolver<TParent>;
  targetClassName?: SchemaPointerFieldToTargetClassNameResolver<TParent>;
}

export interface SchemaPointerFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SchemaPointerFieldToTargetClassNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaPolygonFieldTypeResolver<TParent = any> {
  name?: SchemaPolygonFieldToNameResolver<TParent>;
}

export interface SchemaPolygonFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaRelationFieldTypeResolver<TParent = any> {
  name?: SchemaRelationFieldToNameResolver<TParent>;
  targetClassName?: SchemaRelationFieldToTargetClassNameResolver<TParent>;
}

export interface SchemaRelationFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SchemaRelationFieldToTargetClassNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSchemaStringFieldTypeResolver<TParent = any> {
  name?: SchemaStringFieldToNameResolver<TParent>;
}

export interface SchemaStringFieldToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSendVerificationEmailPayloadTypeResolver<TParent = any> {
  clientMutationId?: SendVerificationEmailPayloadToClientMutationIdResolver<TParent>;
  ok?: SendVerificationEmailPayloadToOkResolver<TParent>;
}

export interface SendVerificationEmailPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SendVerificationEmailPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSessionTypeResolver<TParent = any> {
  ACL?: SessionToACLResolver<TParent>;
  createdAt?: SessionToCreatedAtResolver<TParent>;
  createdWith?: SessionToCreatedWithResolver<TParent>;
  expiresAt?: SessionToExpiresAtResolver<TParent>;
  id?: SessionToIdResolver<TParent>;
  installationId?: SessionToInstallationIdResolver<TParent>;
  objectId?: SessionToObjectIdResolver<TParent>;
  sessionToken?: SessionToSessionTokenResolver<TParent>;
  updatedAt?: SessionToUpdatedAtResolver<TParent>;
  user?: SessionToUserResolver<TParent>;
}

export interface SessionToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToCreatedWithResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToExpiresAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToInstallationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToSessionTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSessionConnectionTypeResolver<TParent = any> {
  count?: SessionConnectionToCountResolver<TParent>;
  edges?: SessionConnectionToEdgesResolver<TParent>;
  pageInfo?: SessionConnectionToPageInfoResolver<TParent>;
}

export interface SessionConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSessionEdgeTypeResolver<TParent = any> {
  cursor?: SessionEdgeToCursorResolver<TParent>;
  node?: SessionEdgeToNodeResolver<TParent>;
}

export interface SessionEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SessionEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSignUpPayloadTypeResolver<TParent = any> {
  clientMutationId?: SignUpPayloadToClientMutationIdResolver<TParent>;
  viewer?: SignUpPayloadToViewerResolver<TParent>;
}

export interface SignUpPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SignUpPayloadToViewerResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateAppFilePayloadTypeResolver<TParent = any> {
  appFile?: UpdateAppFilePayloadToAppFileResolver<TParent>;
  clientMutationId?: UpdateAppFilePayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateAppFilePayloadToAppFileResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateAppFilePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateAuthMetamaskPayloadTypeResolver<TParent = any> {
  authMetamask?: UpdateAuthMetamaskPayloadToAuthMetamaskResolver<TParent>;
  clientMutationId?: UpdateAuthMetamaskPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateAuthMetamaskPayloadToAuthMetamaskResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateAuthMetamaskPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateClassPayloadTypeResolver<TParent = any> {
  class?: UpdateClassPayloadToClassResolver<TParent>;
  clientMutationId?: UpdateClassPayloadToClientMutationIdResolver<TParent>;
}

export interface UpdateClassPayloadToClassResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateClassPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateInstancePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateInstancePayloadToClientMutationIdResolver<TParent>;
  instance?: UpdateInstancePayloadToInstanceResolver<TParent>;
}

export interface UpdateInstancePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateInstancePayloadToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateInstancePaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateInstancePaymentPayloadToClientMutationIdResolver<TParent>;
  instancePayment?: UpdateInstancePaymentPayloadToInstancePaymentResolver<TParent>;
}

export interface UpdateInstancePaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateInstancePaymentPayloadToInstancePaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateInvoicePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateInvoicePayloadToClientMutationIdResolver<TParent>;
  invoice?: UpdateInvoicePayloadToInvoiceResolver<TParent>;
}

export interface UpdateInvoicePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateInvoicePayloadToInvoiceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateRolePayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateRolePayloadToClientMutationIdResolver<TParent>;
  role?: UpdateRolePayloadToRoleResolver<TParent>;
}

export interface UpdateRolePayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateRolePayloadToRoleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateSessionPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateSessionPayloadToClientMutationIdResolver<TParent>;
  session?: UpdateSessionPayloadToSessionResolver<TParent>;
}

export interface UpdateSessionPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateSessionPayloadToSessionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateUserPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateUserPayloadToClientMutationIdResolver<TParent>;
  user?: UpdateUserPayloadToUserResolver<TParent>;
}

export interface UpdateUserPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateUserPayloadToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateValidatorPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateValidatorPayloadToClientMutationIdResolver<TParent>;
  validator?: UpdateValidatorPayloadToValidatorResolver<TParent>;
}

export interface UpdateValidatorPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateValidatorPayloadToValidatorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUpdateValidatorPaymentPayloadTypeResolver<TParent = any> {
  clientMutationId?: UpdateValidatorPaymentPayloadToClientMutationIdResolver<TParent>;
  validatorPayment?: UpdateValidatorPaymentPayloadToValidatorPaymentResolver<TParent>;
}

export interface UpdateValidatorPaymentPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UpdateValidatorPaymentPayloadToValidatorPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserTypeResolver<TParent = any> {
  ACL?: UserToACLResolver<TParent>;
  address?: UserToAddressResolver<TParent>;
  authData?: UserToAuthDataResolver<TParent>;
  authDataResponse?: UserToAuthDataResponseResolver<TParent>;
  createdAt?: UserToCreatedAtResolver<TParent>;
  email?: UserToEmailResolver<TParent>;
  emailVerified?: UserToEmailVerifiedResolver<TParent>;
  id?: UserToIdResolver<TParent>;
  isVerified?: UserToIsVerifiedResolver<TParent>;
  kycData?: UserToKycDataResolver<TParent>;
  objectId?: UserToObjectIdResolver<TParent>;
  sessionId?: UserToSessionIdResolver<TParent>;
  status?: UserToStatusResolver<TParent>;
  stripeId?: UserToStripeIdResolver<TParent>;
  updatedAt?: UserToUpdatedAtResolver<TParent>;
  username?: UserToUsernameResolver<TParent>;
  verificationDate?: UserToVerificationDateResolver<TParent>;
}

export interface UserToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAuthDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToAuthDataResponseResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToEmailVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToIsVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToKycDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToSessionIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToStripeIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToUsernameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserToVerificationDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserACLTypeResolver<TParent = any> {
  read?: UserACLToReadResolver<TParent>;
  userId?: UserACLToUserIdResolver<TParent>;
  write?: UserACLToWriteResolver<TParent>;
}

export interface UserACLToReadResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserACLToUserIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserACLToWriteResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserConnectionTypeResolver<TParent = any> {
  count?: UserConnectionToCountResolver<TParent>;
  edges?: UserConnectionToEdgesResolver<TParent>;
  pageInfo?: UserConnectionToPageInfoResolver<TParent>;
}

export interface UserConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserEdgeTypeResolver<TParent = any> {
  cursor?: UserEdgeToCursorResolver<TParent>;
  node?: UserEdgeToNodeResolver<TParent>;
}

export interface UserEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UserEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLValidatorTypeResolver<TParent = any> {
  ACL?: ValidatorToACLResolver<TParent>;
  Instance?: ValidatorToInstanceResolver<TParent>;
  User?: ValidatorToUserResolver<TParent>;
  activationDate?: ValidatorToActivationDateResolver<TParent>;
  coordinatorBalance?: ValidatorToCoordinatorBalanceResolver<TParent>;
  coordinatorPublicKey?: ValidatorToCoordinatorPublicKeyResolver<TParent>;
  createdAt?: ValidatorToCreatedAtResolver<TParent>;
  depositData?: ValidatorToDepositDataResolver<TParent>;
  depositSent?: ValidatorToDepositSentResolver<TParent>;
  depositTx?: ValidatorToDepositTxResolver<TParent>;
  id?: ValidatorToIdResolver<TParent>;
  index?: ValidatorToIndexResolver<TParent>;
  objectId?: ValidatorToObjectIdResolver<TParent>;
  status?: ValidatorToStatusResolver<TParent>;
  type?: ValidatorToTypeResolver<TParent>;
  updatedAt?: ValidatorToUpdatedAtResolver<TParent>;
  validatorBalance?: ValidatorToValidatorBalanceResolver<TParent>;
  validatorPublicKey?: ValidatorToValidatorPublicKeyResolver<TParent>;
}

export interface ValidatorToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToActivationDateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToCoordinatorBalanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToCoordinatorPublicKeyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToDepositDataResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToDepositSentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToDepositTxResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToIndexResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToValidatorBalanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorToValidatorPublicKeyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLValidatorConnectionTypeResolver<TParent = any> {
  count?: ValidatorConnectionToCountResolver<TParent>;
  edges?: ValidatorConnectionToEdgesResolver<TParent>;
  pageInfo?: ValidatorConnectionToPageInfoResolver<TParent>;
}

export interface ValidatorConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLValidatorEdgeTypeResolver<TParent = any> {
  cursor?: ValidatorEdgeToCursorResolver<TParent>;
  node?: ValidatorEdgeToNodeResolver<TParent>;
}

export interface ValidatorEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLValidatorPaymentTypeResolver<TParent = any> {
  ACL?: ValidatorPaymentToACLResolver<TParent>;
  Instance?: ValidatorPaymentToInstanceResolver<TParent>;
  User?: ValidatorPaymentToUserResolver<TParent>;
  Validators?: ValidatorPaymentToValidatorsResolver<TParent>;
  amount?: ValidatorPaymentToAmountResolver<TParent>;
  createdAt?: ValidatorPaymentToCreatedAtResolver<TParent>;
  error?: ValidatorPaymentToErrorResolver<TParent>;
  id?: ValidatorPaymentToIdResolver<TParent>;
  network?: ValidatorPaymentToNetworkResolver<TParent>;
  objectId?: ValidatorPaymentToObjectIdResolver<TParent>;
  outerId?: ValidatorPaymentToOuterIdResolver<TParent>;
  status?: ValidatorPaymentToStatusResolver<TParent>;
  updatedAt?: ValidatorPaymentToUpdatedAtResolver<TParent>;
}

export interface ValidatorPaymentToACLResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToInstanceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToValidatorsArgs {
  after?: string;
  before?: string;
  first?: number;
  last?: number;
  options?: GQLReadOptionsInput;
  order?: Array<GQLValidatorOrder>;
  skip?: number;
  where?: GQLValidatorWhereInput;
}
export interface ValidatorPaymentToValidatorsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ValidatorPaymentToValidatorsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToCreatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToErrorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToNetworkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToObjectIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToOuterIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToStatusResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentToUpdatedAtResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLValidatorPaymentConnectionTypeResolver<TParent = any> {
  count?: ValidatorPaymentConnectionToCountResolver<TParent>;
  edges?: ValidatorPaymentConnectionToEdgesResolver<TParent>;
  pageInfo?: ValidatorPaymentConnectionToPageInfoResolver<TParent>;
}

export interface ValidatorPaymentConnectionToCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLValidatorPaymentEdgeTypeResolver<TParent = any> {
  cursor?: ValidatorPaymentEdgeToCursorResolver<TParent>;
  node?: ValidatorPaymentEdgeToNodeResolver<TParent>;
}

export interface ValidatorPaymentEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ValidatorPaymentEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLVerifyEmailPayloadTypeResolver<TParent = any> {
  clientMutationId?: VerifyEmailPayloadToClientMutationIdResolver<TParent>;
  ok?: VerifyEmailPayloadToOkResolver<TParent>;
}

export interface VerifyEmailPayloadToClientMutationIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface VerifyEmailPayloadToOkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLViewerTypeResolver<TParent = any> {
  sessionToken?: ViewerToSessionTokenResolver<TParent>;
  user?: ViewerToUserResolver<TParent>;
}

export interface ViewerToSessionTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ViewerToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLZoneTypeResolver<TParent = any> {
  name?: ZoneToNameResolver<TParent>;
  regions?: ZoneToRegionsResolver<TParent>;
}

export interface ZoneToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ZoneToRegionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLgetPaymentConfigPayloadTypeResolver<TParent = any> {
  config?: getPaymentConfigPayloadToConfigResolver<TParent>;
}

export interface getPaymentConfigPayloadToConfigResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}
